/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticateRouteImport } from './routes/authenticate'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthenticatedSignupRouteImport } from './routes/_unauthenticated/signup'
import { Route as UnauthenticatedResetPasswordRouteImport } from './routes/_unauthenticated/reset-password'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedForgotPasswordRouteImport } from './routes/_unauthenticated/forgot-password'
import { Route as UnauthenticatedConfirmEmailRouteImport } from './routes/_unauthenticated/confirm-email'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/_organizations'
import { Route as AuthenticatedOrganizationRouteImport } from './routes/_authenticated/_organization'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/_account'
import { Route as AuthenticatedOrganizationOrganizationSettingsRouteImport } from './routes/_authenticated/_organization/organization-settings'
import { Route as AuthenticatedAccountWaitlistWelcomeRouteImport } from './routes/_authenticated/_account/waitlist-welcome'
import { Route as AuthenticatedAccountLogoutRouteImport } from './routes/_authenticated/_account/logout'
import { Route as AuthenticatedAccountAccountSettingsRouteImport } from './routes/_authenticated/_account/account-settings'
import { Route as AuthenticatedOrganizationsOrganizationsIndexRouteImport } from './routes/_authenticated/_organizations/organizations/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/index'
import { Route as AuthenticatedOrganizationMembersIndexRouteImport } from './routes/_authenticated/_organization/members/index'
import { Route as AuthenticatedOrganizationGovernanceIndexRouteImport } from './routes/_authenticated/_organization/governance/index'
import { Route as AuthenticatedOrganizationFinanceIndexRouteImport } from './routes/_authenticated/_organization/finance/index'
import { Route as AuthenticatedOrganizationEventsIndexRouteImport } from './routes/_authenticated/_organization/events/index'
import { Route as AuthenticatedOrganizationDashboardIndexRouteImport } from './routes/_authenticated/_organization/dashboard/index'
import { Route as AuthenticatedOrganizationContentIndexRouteImport } from './routes/_authenticated/_organization/content/index'
import { Route as AuthenticatedOrganizationCommunicationIndexRouteImport } from './routes/_authenticated/_organization/communication/index'
import { Route as AuthenticatedOrganizationsOrganizationsCreateRouteImport } from './routes/_authenticated/_organizations/organizations/create'
import { Route as AuthenticatedOrganizationOrganizationSettingsIntegrationsRouteImport } from './routes/_authenticated/_organization/organization-settings/integrations'
import { Route as AuthenticatedOrganizationOrganizationSettingsConfirmRouteImport } from './routes/_authenticated/_organization/organization-settings/confirm'
import { Route as AuthenticatedOrganizationMembersMembershipTiersRouteImport } from './routes/_authenticated/_organization/members/membership-tiers'
import { Route as AuthenticatedOrganizationMembersInvitesRouteImport } from './routes/_authenticated/_organization/members/invites'
import { Route as AuthenticatedOrganizationMembersHouseholdsRouteImport } from './routes/_authenticated/_organization/members/households'
import { Route as AuthenticatedOrganizationMembersGroupsCommitteesRouteImport } from './routes/_authenticated/_organization/members/groups-committees'
import { Route as AuthenticatedOrganizationMembersDirectoryRouteImport } from './routes/_authenticated/_organization/members/directory'
import { Route as AuthenticatedOrganizationImportResultUuidRouteImport } from './routes/_authenticated/_organization/import-result/$uuid'
import { Route as AuthenticatedOrganizationGovernanceVotingRouteImport } from './routes/_authenticated/_organization/governance/voting'
import { Route as AuthenticatedOrganizationGovernanceElectionsRouteImport } from './routes/_authenticated/_organization/governance/elections'
import { Route as AuthenticatedOrganizationGovernanceBylawsRouteImport } from './routes/_authenticated/_organization/governance/bylaws'
import { Route as AuthenticatedOrganizationFinanceTransactionsRouteImport } from './routes/_authenticated/_organization/finance/transactions'
import { Route as AuthenticatedOrganizationFinanceReportsRouteImport } from './routes/_authenticated/_organization/finance/reports'
import { Route as AuthenticatedOrganizationFinanceOverviewRouteImport } from './routes/_authenticated/_organization/finance/overview'
import { Route as AuthenticatedOrganizationFinanceOrdersRouteImport } from './routes/_authenticated/_organization/finance/orders'
import { Route as AuthenticatedOrganizationFinanceInvoicesRouteImport } from './routes/_authenticated/_organization/finance/invoices'
import { Route as AuthenticatedOrganizationFinanceFundraisingRouteImport } from './routes/_authenticated/_organization/finance/fundraising'
import { Route as AuthenticatedOrganizationFinanceDuesRouteImport } from './routes/_authenticated/_organization/finance/dues'
import { Route as AuthenticatedOrganizationEventsVolunteeringRouteImport } from './routes/_authenticated/_organization/events/volunteering'
import { Route as AuthenticatedOrganizationEventsCreateRouteImport } from './routes/_authenticated/_organization/events/create'
import { Route as AuthenticatedOrganizationEventsCalendarRouteImport } from './routes/_authenticated/_organization/events/calendar'
import { Route as AuthenticatedOrganizationEventsAttendanceRouteImport } from './routes/_authenticated/_organization/events/attendance'
import { Route as AuthenticatedOrganizationEventsAllEventsRouteImport } from './routes/_authenticated/_organization/events/all-events'
import { Route as AuthenticatedOrganizationEventsEventUuidRouteImport } from './routes/_authenticated/_organization/events/$eventUuid'
import { Route as AuthenticatedOrganizationDashboardRecentActivityRouteImport } from './routes/_authenticated/_organization/dashboard/recent-activity'
import { Route as AuthenticatedOrganizationDashboardOverviewRouteImport } from './routes/_authenticated/_organization/dashboard/overview'
import { Route as AuthenticatedOrganizationDashboardCalendarRouteImport } from './routes/_authenticated/_organization/dashboard/calendar'
import { Route as AuthenticatedOrganizationContentResourcesRouteImport } from './routes/_authenticated/_organization/content/resources'
import { Route as AuthenticatedOrganizationContentMediaRouteImport } from './routes/_authenticated/_organization/content/media'
import { Route as AuthenticatedOrganizationContentDocumentsRouteImport } from './routes/_authenticated/_organization/content/documents'
import { Route as AuthenticatedOrganizationCommunicationTemplatesRouteImport } from './routes/_authenticated/_organization/communication/templates'
import { Route as AuthenticatedOrganizationCommunicationSurveysRouteImport } from './routes/_authenticated/_organization/communication/surveys'
import { Route as AuthenticatedOrganizationCommunicationNewslettersRouteImport } from './routes/_authenticated/_organization/communication/newsletters'
import { Route as AuthenticatedOrganizationCommunicationMessagesRouteImport } from './routes/_authenticated/_organization/communication/messages'
import { Route as AuthenticatedOrganizationCommunicationEmailCampaignsRouteImport } from './routes/_authenticated/_organization/communication/email-campaigns'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsRouteImport } from './routes/_authenticated/_organization/communication/announcements'
import { Route as AuthenticatedOrganizationBillingStripeRefreshRouteImport } from './routes/_authenticated/_organization/billing/stripe-refresh'
import { Route as AuthenticatedOrganizationBillingStripeCompleteRouteImport } from './routes/_authenticated/_organization/billing/stripe-complete'
import { Route as AuthenticatedAccountAccountSettingsTabKeyRouteImport } from './routes/_authenticated/_account/account-settings/$tabKey'
import { Route as AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/roles-permissions/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/organization-profile/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsGeneralIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/general/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsBillingIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/billing/index'
import { Route as AuthenticatedOrganizationMembersHouseholdsIndexRouteImport } from './routes/_authenticated/_organization/members/households/index'
import { Route as AuthenticatedOrganizationMembersGroupsCommitteesIndexRouteImport } from './routes/_authenticated/_organization/members/groups-committees/index'
import { Route as AuthenticatedOrganizationMembersMemberIdIndexRouteImport } from './routes/_authenticated/_organization/members/$memberId/index'
import { Route as AuthenticatedOrganizationFinanceTransactionsIndexRouteImport } from './routes/_authenticated/_organization/finance/transactions/index'
import { Route as AuthenticatedOrganizationFinanceReportsIndexRouteImport } from './routes/_authenticated/_organization/finance/reports/index'
import { Route as AuthenticatedOrganizationFinanceOrdersIndexRouteImport } from './routes/_authenticated/_organization/finance/orders/index'
import { Route as AuthenticatedOrganizationFinanceInvoicesIndexRouteImport } from './routes/_authenticated/_organization/finance/invoices/index'
import { Route as AuthenticatedOrganizationFinanceDuesIndexRouteImport } from './routes/_authenticated/_organization/finance/dues/index'
import { Route as AuthenticatedOrganizationFinanceDonationsIndexRouteImport } from './routes/_authenticated/_organization/finance/donations/index'
import { Route as AuthenticatedOrganizationEventsEventUuidIndexRouteImport } from './routes/_authenticated/_organization/events/$eventUuid/index'
import { Route as AuthenticatedOrganizationCommunicationTemplatesIndexRouteImport } from './routes/_authenticated/_organization/communication/templates/index'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsIndexRouteImport } from './routes/_authenticated/_organization/communication/announcements/index'
import { Route as AuthenticatedAccountInvitationsInvitationUuidIndexRouteImport } from './routes/_authenticated/_account/invitations/$invitationUuid/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRouteImport } from './routes/_authenticated/_organization/organization-settings/organization-profile/$tabKey'
import { Route as AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRouteImport } from './routes/_authenticated/_organization/organization-settings/general/$tabKey'
import { Route as AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRouteImport } from './routes/_authenticated/_organization/organization-settings/billing/stripe-refresh'
import { Route as AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRouteImport } from './routes/_authenticated/_organization/organization-settings/billing/stripe-complete'
import { Route as AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRouteImport } from './routes/_authenticated/_organization/organization-settings/billing/$tabKey'
import { Route as AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRouteImport } from './routes/_authenticated/_organization/members/households/$householdUuid'
import { Route as AuthenticatedOrganizationMembersMemberIdTabKeyRouteImport } from './routes/_authenticated/_organization/members/$memberId/$tabKey'
import { Route as AuthenticatedOrganizationFinanceTransactionsTransactionUuidRouteImport } from './routes/_authenticated/_organization/finance/transactions/$transactionUuid'
import { Route as AuthenticatedOrganizationFinanceReportsTabKeyRouteImport } from './routes/_authenticated/_organization/finance/reports/$tabKey'
import { Route as AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteImport } from './routes/_authenticated/_organization/finance/invoices/$invoiceUuid'
import { Route as AuthenticatedOrganizationFinanceDuesTabKeyRouteImport } from './routes/_authenticated/_organization/finance/dues/$tabKey'
import { Route as AuthenticatedOrganizationFinanceDonationsPagesRouteImport } from './routes/_authenticated/_organization/finance/donations/pages'
import { Route as AuthenticatedOrganizationFinanceDonationsTabKeyRouteImport } from './routes/_authenticated/_organization/finance/donations/$tabKey'
import { Route as AuthenticatedOrganizationEventsEventUuidEditRouteImport } from './routes/_authenticated/_organization/events/$eventUuid/edit'
import { Route as AuthenticatedOrganizationEventsEventUuidTabKeyRouteImport } from './routes/_authenticated/_organization/events/$eventUuid/$tabKey'
import { Route as AuthenticatedOrganizationCommunicationTemplatesNewRouteImport } from './routes/_authenticated/_organization/communication/templates/new'
import { Route as AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRouteImport } from './routes/_authenticated/_organization/communication/templates/$templateUuid'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsNewRouteImport } from './routes/_authenticated/_organization/communication/announcements/new'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteImport } from './routes/_authenticated/_organization/communication/announcements/$announcementUuid'
import { Route as AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRouteImport } from './routes/_authenticated/_account/account-settings/security/trusted-devices'
import { Route as AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRouteImport } from './routes/_authenticated/_account/account-settings/security/social-link-callback'
import { Route as AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRouteImport } from './routes/_authenticated/_account/account-settings/security/phone-verification'
import { Route as AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRouteImport } from './routes/_authenticated/_account/account-settings/security/passkey-management'
import { Route as AuthenticatedAccountAccountSettingsSecurityMfaSetupRouteImport } from './routes/_authenticated/_account/account-settings/security/mfa-setup'
import { Route as AuthenticatedAccountAccountSettingsSecurityMfaMethodRouteImport } from './routes/_authenticated/_account/account-settings/security/mfa-method'
import { Route as AuthenticatedAccountAccountSettingsSecurityChangePasswordRouteImport } from './routes/_authenticated/_account/account-settings/security/change-password'
import { Route as AuthenticatedAccountAccountSettingsSecurityChangeEmailRouteImport } from './routes/_authenticated/_account/account-settings/security/change-email'
import { Route as AuthenticatedAccountAccountSettingsSecurityActivityLogRouteImport } from './routes/_authenticated/_account/account-settings/security/activity-log'
import { Route as AuthenticatedAccountAccountSettingsProfileEditRouteImport } from './routes/_authenticated/_account/account-settings/profile/edit'
import { Route as AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRouteImport } from './routes/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/index'
import { Route as AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRouteImport } from './routes/_authenticated/_organization/members/groups-committees/$groupUuid/index'
import { Route as AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRouteImport } from './routes/_authenticated/_organization/finance/orders/$orderUuid/index'
import { Route as AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRouteImport } from './routes/_authenticated/_organization/finance/invoices/$invoiceUuid/index'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRouteImport } from './routes/_authenticated/_organization/communication/announcements/$announcementUuid/index'
import { Route as AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRouteImport } from './routes/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey'
import { Route as AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRouteImport } from './routes/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey'
import { Route as AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRouteImport } from './routes/_authenticated/_organization/finance/invoices/$invoiceUuid/edit'
import { Route as AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRouteImport } from './routes/_authenticated/_organization/finance/donations/records/$donationUuid'
import { Route as AuthenticatedOrganizationFinanceDonationsPagesCreateRouteImport } from './routes/_authenticated/_organization/finance/donations/pages/create'
import { Route as AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteImport } from './routes/_authenticated/_organization/finance/donations/pages/$pageUuid'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRouteImport } from './routes/_authenticated/_organization/communication/announcements/$announcementUuid/edit'
import { Route as AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRouteImport } from './routes/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey'
import { Route as AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRouteImport } from './routes/_authenticated/_organization/finance/donations/pages/$pageUuid/index'
import { Route as AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRouteImport } from './routes/_authenticated/_organization/finance/donations/pages/$pageUuid/edit'

const AuthenticateRoute = AuthenticateRouteImport.update({
  id: '/authenticate',
  path: '/authenticate',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedSignupRoute = UnauthenticatedSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedResetPasswordRoute =
  UnauthenticatedResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedForgotPasswordRoute =
  UnauthenticatedForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedConfirmEmailRoute =
  UnauthenticatedConfirmEmailRouteImport.update({
    id: '/confirm-email',
    path: '/confirm-email',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsRoute =
  AuthenticatedOrganizationsRouteImport.update({
    id: '/_organizations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationRoute =
  AuthenticatedOrganizationRouteImport.update({
    id: '/_organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/_account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationOrganizationSettingsRoute =
  AuthenticatedOrganizationOrganizationSettingsRouteImport.update({
    id: '/organization-settings',
    path: '/organization-settings',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedAccountWaitlistWelcomeRoute =
  AuthenticatedAccountWaitlistWelcomeRouteImport.update({
    id: '/waitlist-welcome',
    path: '/waitlist-welcome',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountLogoutRoute =
  AuthenticatedAccountLogoutRouteImport.update({
    id: '/logout',
    path: '/logout',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountAccountSettingsRoute =
  AuthenticatedAccountAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationsIndexRoute =
  AuthenticatedOrganizationsOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedOrganizationsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationMembersIndexRoute =
  AuthenticatedOrganizationMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationGovernanceIndexRoute =
  AuthenticatedOrganizationGovernanceIndexRouteImport.update({
    id: '/governance/',
    path: '/governance/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceIndexRoute =
  AuthenticatedOrganizationFinanceIndexRouteImport.update({
    id: '/finance/',
    path: '/finance/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsIndexRoute =
  AuthenticatedOrganizationEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationDashboardIndexRoute =
  AuthenticatedOrganizationDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationContentIndexRoute =
  AuthenticatedOrganizationContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationIndexRoute =
  AuthenticatedOrganizationCommunicationIndexRouteImport.update({
    id: '/communication/',
    path: '/communication/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationsCreateRoute =
  AuthenticatedOrganizationsOrganizationsCreateRouteImport.update({
    id: '/organizations/create',
    path: '/organizations/create',
    getParentRoute: () => AuthenticatedOrganizationsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute =
  AuthenticatedOrganizationOrganizationSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsConfirmRoute =
  AuthenticatedOrganizationOrganizationSettingsConfirmRouteImport.update({
    id: '/confirm',
    path: '/confirm',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationMembersMembershipTiersRoute =
  AuthenticatedOrganizationMembersMembershipTiersRouteImport.update({
    id: '/members/membership-tiers',
    path: '/members/membership-tiers',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationMembersInvitesRoute =
  AuthenticatedOrganizationMembersInvitesRouteImport.update({
    id: '/members/invites',
    path: '/members/invites',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationMembersHouseholdsRoute =
  AuthenticatedOrganizationMembersHouseholdsRouteImport.update({
    id: '/members/households',
    path: '/members/households',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationMembersGroupsCommitteesRoute =
  AuthenticatedOrganizationMembersGroupsCommitteesRouteImport.update({
    id: '/members/groups-committees',
    path: '/members/groups-committees',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationMembersDirectoryRoute =
  AuthenticatedOrganizationMembersDirectoryRouteImport.update({
    id: '/members/directory',
    path: '/members/directory',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationImportResultUuidRoute =
  AuthenticatedOrganizationImportResultUuidRouteImport.update({
    id: '/import-result/$uuid',
    path: '/import-result/$uuid',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationGovernanceVotingRoute =
  AuthenticatedOrganizationGovernanceVotingRouteImport.update({
    id: '/governance/voting',
    path: '/governance/voting',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationGovernanceElectionsRoute =
  AuthenticatedOrganizationGovernanceElectionsRouteImport.update({
    id: '/governance/elections',
    path: '/governance/elections',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationGovernanceBylawsRoute =
  AuthenticatedOrganizationGovernanceBylawsRouteImport.update({
    id: '/governance/bylaws',
    path: '/governance/bylaws',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceTransactionsRoute =
  AuthenticatedOrganizationFinanceTransactionsRouteImport.update({
    id: '/finance/transactions',
    path: '/finance/transactions',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceReportsRoute =
  AuthenticatedOrganizationFinanceReportsRouteImport.update({
    id: '/finance/reports',
    path: '/finance/reports',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceOverviewRoute =
  AuthenticatedOrganizationFinanceOverviewRouteImport.update({
    id: '/finance/overview',
    path: '/finance/overview',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceOrdersRoute =
  AuthenticatedOrganizationFinanceOrdersRouteImport.update({
    id: '/finance/orders',
    path: '/finance/orders',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceInvoicesRoute =
  AuthenticatedOrganizationFinanceInvoicesRouteImport.update({
    id: '/finance/invoices',
    path: '/finance/invoices',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceFundraisingRoute =
  AuthenticatedOrganizationFinanceFundraisingRouteImport.update({
    id: '/finance/fundraising',
    path: '/finance/fundraising',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceDuesRoute =
  AuthenticatedOrganizationFinanceDuesRouteImport.update({
    id: '/finance/dues',
    path: '/finance/dues',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsVolunteeringRoute =
  AuthenticatedOrganizationEventsVolunteeringRouteImport.update({
    id: '/events/volunteering',
    path: '/events/volunteering',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsCreateRoute =
  AuthenticatedOrganizationEventsCreateRouteImport.update({
    id: '/events/create',
    path: '/events/create',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsCalendarRoute =
  AuthenticatedOrganizationEventsCalendarRouteImport.update({
    id: '/events/calendar',
    path: '/events/calendar',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsAttendanceRoute =
  AuthenticatedOrganizationEventsAttendanceRouteImport.update({
    id: '/events/attendance',
    path: '/events/attendance',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsAllEventsRoute =
  AuthenticatedOrganizationEventsAllEventsRouteImport.update({
    id: '/events/all-events',
    path: '/events/all-events',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsEventUuidRoute =
  AuthenticatedOrganizationEventsEventUuidRouteImport.update({
    id: '/events/$eventUuid',
    path: '/events/$eventUuid',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationDashboardRecentActivityRoute =
  AuthenticatedOrganizationDashboardRecentActivityRouteImport.update({
    id: '/dashboard/recent-activity',
    path: '/dashboard/recent-activity',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationDashboardOverviewRoute =
  AuthenticatedOrganizationDashboardOverviewRouteImport.update({
    id: '/dashboard/overview',
    path: '/dashboard/overview',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationDashboardCalendarRoute =
  AuthenticatedOrganizationDashboardCalendarRouteImport.update({
    id: '/dashboard/calendar',
    path: '/dashboard/calendar',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationContentResourcesRoute =
  AuthenticatedOrganizationContentResourcesRouteImport.update({
    id: '/content/resources',
    path: '/content/resources',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationContentMediaRoute =
  AuthenticatedOrganizationContentMediaRouteImport.update({
    id: '/content/media',
    path: '/content/media',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationContentDocumentsRoute =
  AuthenticatedOrganizationContentDocumentsRouteImport.update({
    id: '/content/documents',
    path: '/content/documents',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationTemplatesRoute =
  AuthenticatedOrganizationCommunicationTemplatesRouteImport.update({
    id: '/communication/templates',
    path: '/communication/templates',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationSurveysRoute =
  AuthenticatedOrganizationCommunicationSurveysRouteImport.update({
    id: '/communication/surveys',
    path: '/communication/surveys',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationNewslettersRoute =
  AuthenticatedOrganizationCommunicationNewslettersRouteImport.update({
    id: '/communication/newsletters',
    path: '/communication/newsletters',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationMessagesRoute =
  AuthenticatedOrganizationCommunicationMessagesRouteImport.update({
    id: '/communication/messages',
    path: '/communication/messages',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationEmailCampaignsRoute =
  AuthenticatedOrganizationCommunicationEmailCampaignsRouteImport.update({
    id: '/communication/email-campaigns',
    path: '/communication/email-campaigns',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationCommunicationAnnouncementsRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsRouteImport.update({
    id: '/communication/announcements',
    path: '/communication/announcements',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationBillingStripeRefreshRoute =
  AuthenticatedOrganizationBillingStripeRefreshRouteImport.update({
    id: '/billing/stripe-refresh',
    path: '/billing/stripe-refresh',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationBillingStripeCompleteRoute =
  AuthenticatedOrganizationBillingStripeCompleteRouteImport.update({
    id: '/billing/stripe-complete',
    path: '/billing/stripe-complete',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedAccountAccountSettingsTabKeyRoute =
  AuthenticatedAccountAccountSettingsTabKeyRouteImport.update({
    id: '/$tabKey',
    path: '/$tabKey',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRouteImport.update(
    {
      id: '/roles-permissions/',
      path: '/roles-permissions/',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRouteImport.update(
    {
      id: '/organization-profile/',
      path: '/organization-profile/',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationMembersHouseholdsIndexRoute =
  AuthenticatedOrganizationMembersHouseholdsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationMembersHouseholdsRoute,
  } as any)
const AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute =
  AuthenticatedOrganizationMembersGroupsCommitteesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationMembersGroupsCommitteesRoute,
  } as any)
const AuthenticatedOrganizationMembersMemberIdIndexRoute =
  AuthenticatedOrganizationMembersMemberIdIndexRouteImport.update({
    id: '/members/$memberId/',
    path: '/members/$memberId/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceTransactionsIndexRoute =
  AuthenticatedOrganizationFinanceTransactionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationFinanceTransactionsRoute,
  } as any)
const AuthenticatedOrganizationFinanceReportsIndexRoute =
  AuthenticatedOrganizationFinanceReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationFinanceReportsRoute,
  } as any)
const AuthenticatedOrganizationFinanceOrdersIndexRoute =
  AuthenticatedOrganizationFinanceOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationFinanceOrdersRoute,
  } as any)
const AuthenticatedOrganizationFinanceInvoicesIndexRoute =
  AuthenticatedOrganizationFinanceInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationFinanceInvoicesRoute,
  } as any)
const AuthenticatedOrganizationFinanceDuesIndexRoute =
  AuthenticatedOrganizationFinanceDuesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationFinanceDuesRoute,
  } as any)
const AuthenticatedOrganizationFinanceDonationsIndexRoute =
  AuthenticatedOrganizationFinanceDonationsIndexRouteImport.update({
    id: '/finance/donations/',
    path: '/finance/donations/',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsEventUuidIndexRoute =
  AuthenticatedOrganizationEventsEventUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationEventsEventUuidRoute,
  } as any)
const AuthenticatedOrganizationCommunicationTemplatesIndexRoute =
  AuthenticatedOrganizationCommunicationTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationCommunicationTemplatesRoute,
  } as any)
const AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrganizationCommunicationAnnouncementsRoute,
  } as any)
const AuthenticatedAccountInvitationsInvitationUuidIndexRoute =
  AuthenticatedAccountInvitationsInvitationUuidIndexRouteImport.update({
    id: '/invitations/$invitationUuid/',
    path: '/invitations/$invitationUuid/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute =
  AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRouteImport.update(
    {
      id: '/organization-profile/$tabKey',
      path: '/organization-profile/$tabKey',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute =
  AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRouteImport.update({
    id: '/general/$tabKey',
    path: '/general/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute =
  AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRouteImport.update(
    {
      id: '/billing/stripe-refresh',
      path: '/billing/stripe-refresh',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute =
  AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRouteImport.update(
    {
      id: '/billing/stripe-complete',
      path: '/billing/stripe-complete',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute =
  AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRouteImport.update({
    id: '/billing/$tabKey',
    path: '/billing/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
  } as any)
const AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute =
  AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRouteImport.update({
    id: '/$householdUuid',
    path: '/$householdUuid',
    getParentRoute: () => AuthenticatedOrganizationMembersHouseholdsRoute,
  } as any)
const AuthenticatedOrganizationMembersMemberIdTabKeyRoute =
  AuthenticatedOrganizationMembersMemberIdTabKeyRouteImport.update({
    id: '/members/$memberId/$tabKey',
    path: '/members/$memberId/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute =
  AuthenticatedOrganizationFinanceTransactionsTransactionUuidRouteImport.update(
    {
      id: '/$transactionUuid',
      path: '/$transactionUuid',
      getParentRoute: () => AuthenticatedOrganizationFinanceTransactionsRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceReportsTabKeyRoute =
  AuthenticatedOrganizationFinanceReportsTabKeyRouteImport.update({
    id: '/$tabKey',
    path: '/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationFinanceReportsRoute,
  } as any)
const AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute =
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteImport.update({
    id: '/$invoiceUuid',
    path: '/$invoiceUuid',
    getParentRoute: () => AuthenticatedOrganizationFinanceInvoicesRoute,
  } as any)
const AuthenticatedOrganizationFinanceDuesTabKeyRoute =
  AuthenticatedOrganizationFinanceDuesTabKeyRouteImport.update({
    id: '/$tabKey',
    path: '/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationFinanceDuesRoute,
  } as any)
const AuthenticatedOrganizationFinanceDonationsPagesRoute =
  AuthenticatedOrganizationFinanceDonationsPagesRouteImport.update({
    id: '/finance/donations/pages',
    path: '/finance/donations/pages',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationFinanceDonationsTabKeyRoute =
  AuthenticatedOrganizationFinanceDonationsTabKeyRouteImport.update({
    id: '/finance/donations/$tabKey',
    path: '/finance/donations/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationEventsEventUuidEditRoute =
  AuthenticatedOrganizationEventsEventUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedOrganizationEventsEventUuidRoute,
  } as any)
const AuthenticatedOrganizationEventsEventUuidTabKeyRoute =
  AuthenticatedOrganizationEventsEventUuidTabKeyRouteImport.update({
    id: '/$tabKey',
    path: '/$tabKey',
    getParentRoute: () => AuthenticatedOrganizationEventsEventUuidRoute,
  } as any)
const AuthenticatedOrganizationCommunicationTemplatesNewRoute =
  AuthenticatedOrganizationCommunicationTemplatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedOrganizationCommunicationTemplatesRoute,
  } as any)
const AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute =
  AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRouteImport.update(
    {
      id: '/$templateUuid',
      path: '/$templateUuid',
      getParentRoute: () =>
        AuthenticatedOrganizationCommunicationTemplatesRoute,
    } as any,
  )
const AuthenticatedOrganizationCommunicationAnnouncementsNewRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedOrganizationCommunicationAnnouncementsRoute,
  } as any)
const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteImport.update(
    {
      id: '/$announcementUuid',
      path: '/$announcementUuid',
      getParentRoute: () =>
        AuthenticatedOrganizationCommunicationAnnouncementsRoute,
    } as any,
  )
const AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute =
  AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRouteImport.update({
    id: '/security/trusted-devices',
    path: '/security/trusted-devices',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute =
  AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRouteImport.update(
    {
      id: '/security/social-link-callback',
      path: '/security/social-link-callback',
      getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
    } as any,
  )
const AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute =
  AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRouteImport.update(
    {
      id: '/security/phone-verification',
      path: '/security/phone-verification',
      getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
    } as any,
  )
const AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute =
  AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRouteImport.update(
    {
      id: '/security/passkey-management',
      path: '/security/passkey-management',
      getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
    } as any,
  )
const AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute =
  AuthenticatedAccountAccountSettingsSecurityMfaSetupRouteImport.update({
    id: '/security/mfa-setup',
    path: '/security/mfa-setup',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute =
  AuthenticatedAccountAccountSettingsSecurityMfaMethodRouteImport.update({
    id: '/security/mfa-method',
    path: '/security/mfa-method',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute =
  AuthenticatedAccountAccountSettingsSecurityChangePasswordRouteImport.update({
    id: '/security/change-password',
    path: '/security/change-password',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute =
  AuthenticatedAccountAccountSettingsSecurityChangeEmailRouteImport.update({
    id: '/security/change-email',
    path: '/security/change-email',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsSecurityActivityLogRoute =
  AuthenticatedAccountAccountSettingsSecurityActivityLogRouteImport.update({
    id: '/security/activity-log',
    path: '/security/activity-log',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedAccountAccountSettingsProfileEditRoute =
  AuthenticatedAccountAccountSettingsProfileEditRouteImport.update({
    id: '/profile/edit',
    path: '/profile/edit',
    getParentRoute: () => AuthenticatedAccountAccountSettingsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute =
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRouteImport.update(
    {
      id: '/roles-permissions/$roleUuid/',
      path: '/roles-permissions/$roleUuid/',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute =
  AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRouteImport.update(
    {
      id: '/$groupUuid/',
      path: '/$groupUuid/',
      getParentRoute: () =>
        AuthenticatedOrganizationMembersGroupsCommitteesRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute =
  AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRouteImport.update({
    id: '/$orderUuid/',
    path: '/$orderUuid/',
    getParentRoute: () => AuthenticatedOrganizationFinanceOrdersRoute,
  } as any)
const AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute =
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute,
  } as any)
const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute =
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRouteImport.update(
    {
      id: '/roles-permissions/$roleUuid/$tabKey',
      path: '/roles-permissions/$roleUuid/$tabKey',
      getParentRoute: () => AuthenticatedOrganizationOrganizationSettingsRoute,
    } as any,
  )
const AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute =
  AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRouteImport.update(
    {
      id: '/$groupUuid/$tabKey',
      path: '/$groupUuid/$tabKey',
      getParentRoute: () =>
        AuthenticatedOrganizationMembersGroupsCommitteesRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute =
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute,
  } as any)
const AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute =
  AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRouteImport.update(
    {
      id: '/finance/donations/records/$donationUuid',
      path: '/finance/donations/records/$donationUuid',
      getParentRoute: () => AuthenticatedOrganizationRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceDonationsPagesCreateRoute =
  AuthenticatedOrganizationFinanceDonationsPagesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedOrganizationFinanceDonationsPagesRoute,
  } as any)
const AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute =
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteImport.update({
    id: '/$pageUuid',
    path: '/$pageUuid',
    getParentRoute: () => AuthenticatedOrganizationFinanceDonationsPagesRoute,
  } as any)
const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute,
    } as any,
  )
const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute =
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRouteImport.update(
    {
      id: '/$tabKey',
      path: '/$tabKey',
      getParentRoute: () =>
        AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute =
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute,
    } as any,
  )
const AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute =
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authenticate': typeof AuthenticateRoute
  '/confirm-email': typeof UnauthenticatedConfirmEmailRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/account-settings': typeof AuthenticatedAccountAccountSettingsRouteWithChildren
  '/logout': typeof AuthenticatedAccountLogoutRoute
  '/waitlist-welcome': typeof AuthenticatedAccountWaitlistWelcomeRoute
  '/organization-settings': typeof AuthenticatedOrganizationOrganizationSettingsRouteWithChildren
  '/account-settings/$tabKey': typeof AuthenticatedAccountAccountSettingsTabKeyRoute
  '/billing/stripe-complete': typeof AuthenticatedOrganizationBillingStripeCompleteRoute
  '/billing/stripe-refresh': typeof AuthenticatedOrganizationBillingStripeRefreshRoute
  '/communication/announcements': typeof AuthenticatedOrganizationCommunicationAnnouncementsRouteWithChildren
  '/communication/email-campaigns': typeof AuthenticatedOrganizationCommunicationEmailCampaignsRoute
  '/communication/messages': typeof AuthenticatedOrganizationCommunicationMessagesRoute
  '/communication/newsletters': typeof AuthenticatedOrganizationCommunicationNewslettersRoute
  '/communication/surveys': typeof AuthenticatedOrganizationCommunicationSurveysRoute
  '/communication/templates': typeof AuthenticatedOrganizationCommunicationTemplatesRouteWithChildren
  '/content/documents': typeof AuthenticatedOrganizationContentDocumentsRoute
  '/content/media': typeof AuthenticatedOrganizationContentMediaRoute
  '/content/resources': typeof AuthenticatedOrganizationContentResourcesRoute
  '/dashboard/calendar': typeof AuthenticatedOrganizationDashboardCalendarRoute
  '/dashboard/overview': typeof AuthenticatedOrganizationDashboardOverviewRoute
  '/dashboard/recent-activity': typeof AuthenticatedOrganizationDashboardRecentActivityRoute
  '/events/$eventUuid': typeof AuthenticatedOrganizationEventsEventUuidRouteWithChildren
  '/events/all-events': typeof AuthenticatedOrganizationEventsAllEventsRoute
  '/events/attendance': typeof AuthenticatedOrganizationEventsAttendanceRoute
  '/events/calendar': typeof AuthenticatedOrganizationEventsCalendarRoute
  '/events/create': typeof AuthenticatedOrganizationEventsCreateRoute
  '/events/volunteering': typeof AuthenticatedOrganizationEventsVolunteeringRoute
  '/finance/dues': typeof AuthenticatedOrganizationFinanceDuesRouteWithChildren
  '/finance/fundraising': typeof AuthenticatedOrganizationFinanceFundraisingRoute
  '/finance/invoices': typeof AuthenticatedOrganizationFinanceInvoicesRouteWithChildren
  '/finance/orders': typeof AuthenticatedOrganizationFinanceOrdersRouteWithChildren
  '/finance/overview': typeof AuthenticatedOrganizationFinanceOverviewRoute
  '/finance/reports': typeof AuthenticatedOrganizationFinanceReportsRouteWithChildren
  '/finance/transactions': typeof AuthenticatedOrganizationFinanceTransactionsRouteWithChildren
  '/governance/bylaws': typeof AuthenticatedOrganizationGovernanceBylawsRoute
  '/governance/elections': typeof AuthenticatedOrganizationGovernanceElectionsRoute
  '/governance/voting': typeof AuthenticatedOrganizationGovernanceVotingRoute
  '/import-result/$uuid': typeof AuthenticatedOrganizationImportResultUuidRoute
  '/members/directory': typeof AuthenticatedOrganizationMembersDirectoryRoute
  '/members/groups-committees': typeof AuthenticatedOrganizationMembersGroupsCommitteesRouteWithChildren
  '/members/households': typeof AuthenticatedOrganizationMembersHouseholdsRouteWithChildren
  '/members/invites': typeof AuthenticatedOrganizationMembersInvitesRoute
  '/members/membership-tiers': typeof AuthenticatedOrganizationMembersMembershipTiersRoute
  '/organization-settings/confirm': typeof AuthenticatedOrganizationOrganizationSettingsConfirmRoute
  '/organization-settings/integrations': typeof AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute
  '/organizations/create': typeof AuthenticatedOrganizationsOrganizationsCreateRoute
  '/communication': typeof AuthenticatedOrganizationCommunicationIndexRoute
  '/content': typeof AuthenticatedOrganizationContentIndexRoute
  '/dashboard': typeof AuthenticatedOrganizationDashboardIndexRoute
  '/events': typeof AuthenticatedOrganizationEventsIndexRoute
  '/finance': typeof AuthenticatedOrganizationFinanceIndexRoute
  '/governance': typeof AuthenticatedOrganizationGovernanceIndexRoute
  '/members': typeof AuthenticatedOrganizationMembersIndexRoute
  '/organization-settings/': typeof AuthenticatedOrganizationOrganizationSettingsIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsOrganizationsIndexRoute
  '/account-settings/profile/edit': typeof AuthenticatedAccountAccountSettingsProfileEditRoute
  '/account-settings/security/activity-log': typeof AuthenticatedAccountAccountSettingsSecurityActivityLogRoute
  '/account-settings/security/change-email': typeof AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute
  '/account-settings/security/change-password': typeof AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute
  '/account-settings/security/mfa-method': typeof AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute
  '/account-settings/security/mfa-setup': typeof AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute
  '/account-settings/security/passkey-management': typeof AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute
  '/account-settings/security/phone-verification': typeof AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute
  '/account-settings/security/social-link-callback': typeof AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute
  '/account-settings/security/trusted-devices': typeof AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute
  '/communication/announcements/$announcementUuid': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteWithChildren
  '/communication/announcements/new': typeof AuthenticatedOrganizationCommunicationAnnouncementsNewRoute
  '/communication/templates/$templateUuid': typeof AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute
  '/communication/templates/new': typeof AuthenticatedOrganizationCommunicationTemplatesNewRoute
  '/events/$eventUuid/$tabKey': typeof AuthenticatedOrganizationEventsEventUuidTabKeyRoute
  '/events/$eventUuid/edit': typeof AuthenticatedOrganizationEventsEventUuidEditRoute
  '/finance/donations/$tabKey': typeof AuthenticatedOrganizationFinanceDonationsTabKeyRoute
  '/finance/donations/pages': typeof AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren
  '/finance/dues/$tabKey': typeof AuthenticatedOrganizationFinanceDuesTabKeyRoute
  '/finance/invoices/$invoiceUuid': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteWithChildren
  '/finance/reports/$tabKey': typeof AuthenticatedOrganizationFinanceReportsTabKeyRoute
  '/finance/transactions/$transactionUuid': typeof AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute
  '/members/$memberId/$tabKey': typeof AuthenticatedOrganizationMembersMemberIdTabKeyRoute
  '/members/households/$householdUuid': typeof AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute
  '/organization-settings/billing/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute
  '/organization-settings/billing/stripe-complete': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute
  '/organization-settings/billing/stripe-refresh': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute
  '/organization-settings/general/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute
  '/organization-settings/organization-profile/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute
  '/invitations/$invitationUuid': typeof AuthenticatedAccountInvitationsInvitationUuidIndexRoute
  '/communication/announcements/': typeof AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute
  '/communication/templates/': typeof AuthenticatedOrganizationCommunicationTemplatesIndexRoute
  '/events/$eventUuid/': typeof AuthenticatedOrganizationEventsEventUuidIndexRoute
  '/finance/donations': typeof AuthenticatedOrganizationFinanceDonationsIndexRoute
  '/finance/dues/': typeof AuthenticatedOrganizationFinanceDuesIndexRoute
  '/finance/invoices/': typeof AuthenticatedOrganizationFinanceInvoicesIndexRoute
  '/finance/orders/': typeof AuthenticatedOrganizationFinanceOrdersIndexRoute
  '/finance/reports/': typeof AuthenticatedOrganizationFinanceReportsIndexRoute
  '/finance/transactions/': typeof AuthenticatedOrganizationFinanceTransactionsIndexRoute
  '/members/$memberId': typeof AuthenticatedOrganizationMembersMemberIdIndexRoute
  '/members/groups-committees/': typeof AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute
  '/members/households/': typeof AuthenticatedOrganizationMembersHouseholdsIndexRoute
  '/organization-settings/billing': typeof AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute
  '/organization-settings/general': typeof AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute
  '/organization-settings/organization-profile': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute
  '/organization-settings/roles-permissions': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute
  '/communication/announcements/$announcementUuid/$tabKey': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute
  '/communication/announcements/$announcementUuid/edit': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute
  '/finance/donations/pages/$pageUuid': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteWithChildren
  '/finance/donations/pages/create': typeof AuthenticatedOrganizationFinanceDonationsPagesCreateRoute
  '/finance/donations/records/$donationUuid': typeof AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute
  '/finance/invoices/$invoiceUuid/edit': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute
  '/members/groups-committees/$groupUuid/$tabKey': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute
  '/organization-settings/roles-permissions/$roleUuid/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute
  '/communication/announcements/$announcementUuid/': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute
  '/finance/invoices/$invoiceUuid/': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute
  '/finance/orders/$orderUuid': typeof AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute
  '/members/groups-committees/$groupUuid': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute
  '/organization-settings/roles-permissions/$roleUuid': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute
  '/finance/donations/pages/$pageUuid/edit': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute
  '/finance/donations/pages/$pageUuid/': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authenticate': typeof AuthenticateRoute
  '/confirm-email': typeof UnauthenticatedConfirmEmailRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/account-settings': typeof AuthenticatedAccountAccountSettingsRouteWithChildren
  '/logout': typeof AuthenticatedAccountLogoutRoute
  '/waitlist-welcome': typeof AuthenticatedAccountWaitlistWelcomeRoute
  '/account-settings/$tabKey': typeof AuthenticatedAccountAccountSettingsTabKeyRoute
  '/billing/stripe-complete': typeof AuthenticatedOrganizationBillingStripeCompleteRoute
  '/billing/stripe-refresh': typeof AuthenticatedOrganizationBillingStripeRefreshRoute
  '/communication/email-campaigns': typeof AuthenticatedOrganizationCommunicationEmailCampaignsRoute
  '/communication/messages': typeof AuthenticatedOrganizationCommunicationMessagesRoute
  '/communication/newsletters': typeof AuthenticatedOrganizationCommunicationNewslettersRoute
  '/communication/surveys': typeof AuthenticatedOrganizationCommunicationSurveysRoute
  '/content/documents': typeof AuthenticatedOrganizationContentDocumentsRoute
  '/content/media': typeof AuthenticatedOrganizationContentMediaRoute
  '/content/resources': typeof AuthenticatedOrganizationContentResourcesRoute
  '/dashboard/calendar': typeof AuthenticatedOrganizationDashboardCalendarRoute
  '/dashboard/overview': typeof AuthenticatedOrganizationDashboardOverviewRoute
  '/dashboard/recent-activity': typeof AuthenticatedOrganizationDashboardRecentActivityRoute
  '/events/all-events': typeof AuthenticatedOrganizationEventsAllEventsRoute
  '/events/attendance': typeof AuthenticatedOrganizationEventsAttendanceRoute
  '/events/calendar': typeof AuthenticatedOrganizationEventsCalendarRoute
  '/events/create': typeof AuthenticatedOrganizationEventsCreateRoute
  '/events/volunteering': typeof AuthenticatedOrganizationEventsVolunteeringRoute
  '/finance/fundraising': typeof AuthenticatedOrganizationFinanceFundraisingRoute
  '/finance/overview': typeof AuthenticatedOrganizationFinanceOverviewRoute
  '/governance/bylaws': typeof AuthenticatedOrganizationGovernanceBylawsRoute
  '/governance/elections': typeof AuthenticatedOrganizationGovernanceElectionsRoute
  '/governance/voting': typeof AuthenticatedOrganizationGovernanceVotingRoute
  '/import-result/$uuid': typeof AuthenticatedOrganizationImportResultUuidRoute
  '/members/directory': typeof AuthenticatedOrganizationMembersDirectoryRoute
  '/members/invites': typeof AuthenticatedOrganizationMembersInvitesRoute
  '/members/membership-tiers': typeof AuthenticatedOrganizationMembersMembershipTiersRoute
  '/organization-settings/confirm': typeof AuthenticatedOrganizationOrganizationSettingsConfirmRoute
  '/organization-settings/integrations': typeof AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute
  '/organizations/create': typeof AuthenticatedOrganizationsOrganizationsCreateRoute
  '/communication': typeof AuthenticatedOrganizationCommunicationIndexRoute
  '/content': typeof AuthenticatedOrganizationContentIndexRoute
  '/dashboard': typeof AuthenticatedOrganizationDashboardIndexRoute
  '/events': typeof AuthenticatedOrganizationEventsIndexRoute
  '/finance': typeof AuthenticatedOrganizationFinanceIndexRoute
  '/governance': typeof AuthenticatedOrganizationGovernanceIndexRoute
  '/members': typeof AuthenticatedOrganizationMembersIndexRoute
  '/organization-settings': typeof AuthenticatedOrganizationOrganizationSettingsIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsOrganizationsIndexRoute
  '/account-settings/profile/edit': typeof AuthenticatedAccountAccountSettingsProfileEditRoute
  '/account-settings/security/activity-log': typeof AuthenticatedAccountAccountSettingsSecurityActivityLogRoute
  '/account-settings/security/change-email': typeof AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute
  '/account-settings/security/change-password': typeof AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute
  '/account-settings/security/mfa-method': typeof AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute
  '/account-settings/security/mfa-setup': typeof AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute
  '/account-settings/security/passkey-management': typeof AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute
  '/account-settings/security/phone-verification': typeof AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute
  '/account-settings/security/social-link-callback': typeof AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute
  '/account-settings/security/trusted-devices': typeof AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute
  '/communication/announcements/new': typeof AuthenticatedOrganizationCommunicationAnnouncementsNewRoute
  '/communication/templates/$templateUuid': typeof AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute
  '/communication/templates/new': typeof AuthenticatedOrganizationCommunicationTemplatesNewRoute
  '/events/$eventUuid/$tabKey': typeof AuthenticatedOrganizationEventsEventUuidTabKeyRoute
  '/events/$eventUuid/edit': typeof AuthenticatedOrganizationEventsEventUuidEditRoute
  '/finance/donations/$tabKey': typeof AuthenticatedOrganizationFinanceDonationsTabKeyRoute
  '/finance/donations/pages': typeof AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren
  '/finance/dues/$tabKey': typeof AuthenticatedOrganizationFinanceDuesTabKeyRoute
  '/finance/reports/$tabKey': typeof AuthenticatedOrganizationFinanceReportsTabKeyRoute
  '/finance/transactions/$transactionUuid': typeof AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute
  '/members/$memberId/$tabKey': typeof AuthenticatedOrganizationMembersMemberIdTabKeyRoute
  '/members/households/$householdUuid': typeof AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute
  '/organization-settings/billing/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute
  '/organization-settings/billing/stripe-complete': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute
  '/organization-settings/billing/stripe-refresh': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute
  '/organization-settings/general/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute
  '/organization-settings/organization-profile/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute
  '/invitations/$invitationUuid': typeof AuthenticatedAccountInvitationsInvitationUuidIndexRoute
  '/communication/announcements': typeof AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute
  '/communication/templates': typeof AuthenticatedOrganizationCommunicationTemplatesIndexRoute
  '/events/$eventUuid': typeof AuthenticatedOrganizationEventsEventUuidIndexRoute
  '/finance/donations': typeof AuthenticatedOrganizationFinanceDonationsIndexRoute
  '/finance/dues': typeof AuthenticatedOrganizationFinanceDuesIndexRoute
  '/finance/invoices': typeof AuthenticatedOrganizationFinanceInvoicesIndexRoute
  '/finance/orders': typeof AuthenticatedOrganizationFinanceOrdersIndexRoute
  '/finance/reports': typeof AuthenticatedOrganizationFinanceReportsIndexRoute
  '/finance/transactions': typeof AuthenticatedOrganizationFinanceTransactionsIndexRoute
  '/members/$memberId': typeof AuthenticatedOrganizationMembersMemberIdIndexRoute
  '/members/groups-committees': typeof AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute
  '/members/households': typeof AuthenticatedOrganizationMembersHouseholdsIndexRoute
  '/organization-settings/billing': typeof AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute
  '/organization-settings/general': typeof AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute
  '/organization-settings/organization-profile': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute
  '/organization-settings/roles-permissions': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute
  '/communication/announcements/$announcementUuid/$tabKey': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute
  '/communication/announcements/$announcementUuid/edit': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute
  '/finance/donations/pages/create': typeof AuthenticatedOrganizationFinanceDonationsPagesCreateRoute
  '/finance/donations/records/$donationUuid': typeof AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute
  '/finance/invoices/$invoiceUuid/edit': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute
  '/members/groups-committees/$groupUuid/$tabKey': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute
  '/organization-settings/roles-permissions/$roleUuid/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute
  '/communication/announcements/$announcementUuid': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute
  '/finance/invoices/$invoiceUuid': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute
  '/finance/orders/$orderUuid': typeof AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute
  '/members/groups-committees/$groupUuid': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute
  '/organization-settings/roles-permissions/$roleUuid': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute
  '/finance/donations/pages/$pageUuid/edit': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute
  '/finance/donations/pages/$pageUuid': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/authenticate': typeof AuthenticateRoute
  '/_authenticated/_account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/_organization': typeof AuthenticatedOrganizationRouteWithChildren
  '/_authenticated/_organizations': typeof AuthenticatedOrganizationsRouteWithChildren
  '/_unauthenticated/confirm-email': typeof UnauthenticatedConfirmEmailRoute
  '/_unauthenticated/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/_unauthenticated/signup': typeof UnauthenticatedSignupRoute
  '/_authenticated/_account/account-settings': typeof AuthenticatedAccountAccountSettingsRouteWithChildren
  '/_authenticated/_account/logout': typeof AuthenticatedAccountLogoutRoute
  '/_authenticated/_account/waitlist-welcome': typeof AuthenticatedAccountWaitlistWelcomeRoute
  '/_authenticated/_organization/organization-settings': typeof AuthenticatedOrganizationOrganizationSettingsRouteWithChildren
  '/_authenticated/_account/account-settings/$tabKey': typeof AuthenticatedAccountAccountSettingsTabKeyRoute
  '/_authenticated/_organization/billing/stripe-complete': typeof AuthenticatedOrganizationBillingStripeCompleteRoute
  '/_authenticated/_organization/billing/stripe-refresh': typeof AuthenticatedOrganizationBillingStripeRefreshRoute
  '/_authenticated/_organization/communication/announcements': typeof AuthenticatedOrganizationCommunicationAnnouncementsRouteWithChildren
  '/_authenticated/_organization/communication/email-campaigns': typeof AuthenticatedOrganizationCommunicationEmailCampaignsRoute
  '/_authenticated/_organization/communication/messages': typeof AuthenticatedOrganizationCommunicationMessagesRoute
  '/_authenticated/_organization/communication/newsletters': typeof AuthenticatedOrganizationCommunicationNewslettersRoute
  '/_authenticated/_organization/communication/surveys': typeof AuthenticatedOrganizationCommunicationSurveysRoute
  '/_authenticated/_organization/communication/templates': typeof AuthenticatedOrganizationCommunicationTemplatesRouteWithChildren
  '/_authenticated/_organization/content/documents': typeof AuthenticatedOrganizationContentDocumentsRoute
  '/_authenticated/_organization/content/media': typeof AuthenticatedOrganizationContentMediaRoute
  '/_authenticated/_organization/content/resources': typeof AuthenticatedOrganizationContentResourcesRoute
  '/_authenticated/_organization/dashboard/calendar': typeof AuthenticatedOrganizationDashboardCalendarRoute
  '/_authenticated/_organization/dashboard/overview': typeof AuthenticatedOrganizationDashboardOverviewRoute
  '/_authenticated/_organization/dashboard/recent-activity': typeof AuthenticatedOrganizationDashboardRecentActivityRoute
  '/_authenticated/_organization/events/$eventUuid': typeof AuthenticatedOrganizationEventsEventUuidRouteWithChildren
  '/_authenticated/_organization/events/all-events': typeof AuthenticatedOrganizationEventsAllEventsRoute
  '/_authenticated/_organization/events/attendance': typeof AuthenticatedOrganizationEventsAttendanceRoute
  '/_authenticated/_organization/events/calendar': typeof AuthenticatedOrganizationEventsCalendarRoute
  '/_authenticated/_organization/events/create': typeof AuthenticatedOrganizationEventsCreateRoute
  '/_authenticated/_organization/events/volunteering': typeof AuthenticatedOrganizationEventsVolunteeringRoute
  '/_authenticated/_organization/finance/dues': typeof AuthenticatedOrganizationFinanceDuesRouteWithChildren
  '/_authenticated/_organization/finance/fundraising': typeof AuthenticatedOrganizationFinanceFundraisingRoute
  '/_authenticated/_organization/finance/invoices': typeof AuthenticatedOrganizationFinanceInvoicesRouteWithChildren
  '/_authenticated/_organization/finance/orders': typeof AuthenticatedOrganizationFinanceOrdersRouteWithChildren
  '/_authenticated/_organization/finance/overview': typeof AuthenticatedOrganizationFinanceOverviewRoute
  '/_authenticated/_organization/finance/reports': typeof AuthenticatedOrganizationFinanceReportsRouteWithChildren
  '/_authenticated/_organization/finance/transactions': typeof AuthenticatedOrganizationFinanceTransactionsRouteWithChildren
  '/_authenticated/_organization/governance/bylaws': typeof AuthenticatedOrganizationGovernanceBylawsRoute
  '/_authenticated/_organization/governance/elections': typeof AuthenticatedOrganizationGovernanceElectionsRoute
  '/_authenticated/_organization/governance/voting': typeof AuthenticatedOrganizationGovernanceVotingRoute
  '/_authenticated/_organization/import-result/$uuid': typeof AuthenticatedOrganizationImportResultUuidRoute
  '/_authenticated/_organization/members/directory': typeof AuthenticatedOrganizationMembersDirectoryRoute
  '/_authenticated/_organization/members/groups-committees': typeof AuthenticatedOrganizationMembersGroupsCommitteesRouteWithChildren
  '/_authenticated/_organization/members/households': typeof AuthenticatedOrganizationMembersHouseholdsRouteWithChildren
  '/_authenticated/_organization/members/invites': typeof AuthenticatedOrganizationMembersInvitesRoute
  '/_authenticated/_organization/members/membership-tiers': typeof AuthenticatedOrganizationMembersMembershipTiersRoute
  '/_authenticated/_organization/organization-settings/confirm': typeof AuthenticatedOrganizationOrganizationSettingsConfirmRoute
  '/_authenticated/_organization/organization-settings/integrations': typeof AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute
  '/_authenticated/_organizations/organizations/create': typeof AuthenticatedOrganizationsOrganizationsCreateRoute
  '/_authenticated/_organization/communication/': typeof AuthenticatedOrganizationCommunicationIndexRoute
  '/_authenticated/_organization/content/': typeof AuthenticatedOrganizationContentIndexRoute
  '/_authenticated/_organization/dashboard/': typeof AuthenticatedOrganizationDashboardIndexRoute
  '/_authenticated/_organization/events/': typeof AuthenticatedOrganizationEventsIndexRoute
  '/_authenticated/_organization/finance/': typeof AuthenticatedOrganizationFinanceIndexRoute
  '/_authenticated/_organization/governance/': typeof AuthenticatedOrganizationGovernanceIndexRoute
  '/_authenticated/_organization/members/': typeof AuthenticatedOrganizationMembersIndexRoute
  '/_authenticated/_organization/organization-settings/': typeof AuthenticatedOrganizationOrganizationSettingsIndexRoute
  '/_authenticated/_organizations/organizations/': typeof AuthenticatedOrganizationsOrganizationsIndexRoute
  '/_authenticated/_account/account-settings/profile/edit': typeof AuthenticatedAccountAccountSettingsProfileEditRoute
  '/_authenticated/_account/account-settings/security/activity-log': typeof AuthenticatedAccountAccountSettingsSecurityActivityLogRoute
  '/_authenticated/_account/account-settings/security/change-email': typeof AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute
  '/_authenticated/_account/account-settings/security/change-password': typeof AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute
  '/_authenticated/_account/account-settings/security/mfa-method': typeof AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute
  '/_authenticated/_account/account-settings/security/mfa-setup': typeof AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute
  '/_authenticated/_account/account-settings/security/passkey-management': typeof AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute
  '/_authenticated/_account/account-settings/security/phone-verification': typeof AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute
  '/_authenticated/_account/account-settings/security/social-link-callback': typeof AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute
  '/_authenticated/_account/account-settings/security/trusted-devices': typeof AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute
  '/_authenticated/_organization/communication/announcements/$announcementUuid': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteWithChildren
  '/_authenticated/_organization/communication/announcements/new': typeof AuthenticatedOrganizationCommunicationAnnouncementsNewRoute
  '/_authenticated/_organization/communication/templates/$templateUuid': typeof AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute
  '/_authenticated/_organization/communication/templates/new': typeof AuthenticatedOrganizationCommunicationTemplatesNewRoute
  '/_authenticated/_organization/events/$eventUuid/$tabKey': typeof AuthenticatedOrganizationEventsEventUuidTabKeyRoute
  '/_authenticated/_organization/events/$eventUuid/edit': typeof AuthenticatedOrganizationEventsEventUuidEditRoute
  '/_authenticated/_organization/finance/donations/$tabKey': typeof AuthenticatedOrganizationFinanceDonationsTabKeyRoute
  '/_authenticated/_organization/finance/donations/pages': typeof AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren
  '/_authenticated/_organization/finance/dues/$tabKey': typeof AuthenticatedOrganizationFinanceDuesTabKeyRoute
  '/_authenticated/_organization/finance/invoices/$invoiceUuid': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteWithChildren
  '/_authenticated/_organization/finance/reports/$tabKey': typeof AuthenticatedOrganizationFinanceReportsTabKeyRoute
  '/_authenticated/_organization/finance/transactions/$transactionUuid': typeof AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute
  '/_authenticated/_organization/members/$memberId/$tabKey': typeof AuthenticatedOrganizationMembersMemberIdTabKeyRoute
  '/_authenticated/_organization/members/households/$householdUuid': typeof AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute
  '/_authenticated/_organization/organization-settings/billing/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute
  '/_authenticated/_organization/organization-settings/billing/stripe-complete': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute
  '/_authenticated/_organization/organization-settings/billing/stripe-refresh': typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute
  '/_authenticated/_organization/organization-settings/general/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute
  '/_authenticated/_organization/organization-settings/organization-profile/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute
  '/_authenticated/_account/invitations/$invitationUuid/': typeof AuthenticatedAccountInvitationsInvitationUuidIndexRoute
  '/_authenticated/_organization/communication/announcements/': typeof AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute
  '/_authenticated/_organization/communication/templates/': typeof AuthenticatedOrganizationCommunicationTemplatesIndexRoute
  '/_authenticated/_organization/events/$eventUuid/': typeof AuthenticatedOrganizationEventsEventUuidIndexRoute
  '/_authenticated/_organization/finance/donations/': typeof AuthenticatedOrganizationFinanceDonationsIndexRoute
  '/_authenticated/_organization/finance/dues/': typeof AuthenticatedOrganizationFinanceDuesIndexRoute
  '/_authenticated/_organization/finance/invoices/': typeof AuthenticatedOrganizationFinanceInvoicesIndexRoute
  '/_authenticated/_organization/finance/orders/': typeof AuthenticatedOrganizationFinanceOrdersIndexRoute
  '/_authenticated/_organization/finance/reports/': typeof AuthenticatedOrganizationFinanceReportsIndexRoute
  '/_authenticated/_organization/finance/transactions/': typeof AuthenticatedOrganizationFinanceTransactionsIndexRoute
  '/_authenticated/_organization/members/$memberId/': typeof AuthenticatedOrganizationMembersMemberIdIndexRoute
  '/_authenticated/_organization/members/groups-committees/': typeof AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute
  '/_authenticated/_organization/members/households/': typeof AuthenticatedOrganizationMembersHouseholdsIndexRoute
  '/_authenticated/_organization/organization-settings/billing/': typeof AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute
  '/_authenticated/_organization/organization-settings/general/': typeof AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute
  '/_authenticated/_organization/organization-settings/organization-profile/': typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute
  '/_authenticated/_organization/organization-settings/roles-permissions/': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute
  '/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute
  '/_authenticated/_organization/communication/announcements/$announcementUuid/edit': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute
  '/_authenticated/_organization/finance/donations/pages/$pageUuid': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteWithChildren
  '/_authenticated/_organization/finance/donations/pages/create': typeof AuthenticatedOrganizationFinanceDonationsPagesCreateRoute
  '/_authenticated/_organization/finance/donations/records/$donationUuid': typeof AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute
  '/_authenticated/_organization/finance/invoices/$invoiceUuid/edit': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute
  '/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute
  '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute
  '/_authenticated/_organization/communication/announcements/$announcementUuid/': typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute
  '/_authenticated/_organization/finance/invoices/$invoiceUuid/': typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute
  '/_authenticated/_organization/finance/orders/$orderUuid/': typeof AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute
  '/_authenticated/_organization/members/groups-committees/$groupUuid/': typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute
  '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/': typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute
  '/_authenticated/_organization/finance/donations/pages/$pageUuid/edit': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute
  '/_authenticated/_organization/finance/donations/pages/$pageUuid/': typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authenticate'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/account-settings'
    | '/logout'
    | '/waitlist-welcome'
    | '/organization-settings'
    | '/account-settings/$tabKey'
    | '/billing/stripe-complete'
    | '/billing/stripe-refresh'
    | '/communication/announcements'
    | '/communication/email-campaigns'
    | '/communication/messages'
    | '/communication/newsletters'
    | '/communication/surveys'
    | '/communication/templates'
    | '/content/documents'
    | '/content/media'
    | '/content/resources'
    | '/dashboard/calendar'
    | '/dashboard/overview'
    | '/dashboard/recent-activity'
    | '/events/$eventUuid'
    | '/events/all-events'
    | '/events/attendance'
    | '/events/calendar'
    | '/events/create'
    | '/events/volunteering'
    | '/finance/dues'
    | '/finance/fundraising'
    | '/finance/invoices'
    | '/finance/orders'
    | '/finance/overview'
    | '/finance/reports'
    | '/finance/transactions'
    | '/governance/bylaws'
    | '/governance/elections'
    | '/governance/voting'
    | '/import-result/$uuid'
    | '/members/directory'
    | '/members/groups-committees'
    | '/members/households'
    | '/members/invites'
    | '/members/membership-tiers'
    | '/organization-settings/confirm'
    | '/organization-settings/integrations'
    | '/organizations/create'
    | '/communication'
    | '/content'
    | '/dashboard'
    | '/events'
    | '/finance'
    | '/governance'
    | '/members'
    | '/organization-settings/'
    | '/organizations'
    | '/account-settings/profile/edit'
    | '/account-settings/security/activity-log'
    | '/account-settings/security/change-email'
    | '/account-settings/security/change-password'
    | '/account-settings/security/mfa-method'
    | '/account-settings/security/mfa-setup'
    | '/account-settings/security/passkey-management'
    | '/account-settings/security/phone-verification'
    | '/account-settings/security/social-link-callback'
    | '/account-settings/security/trusted-devices'
    | '/communication/announcements/$announcementUuid'
    | '/communication/announcements/new'
    | '/communication/templates/$templateUuid'
    | '/communication/templates/new'
    | '/events/$eventUuid/$tabKey'
    | '/events/$eventUuid/edit'
    | '/finance/donations/$tabKey'
    | '/finance/donations/pages'
    | '/finance/dues/$tabKey'
    | '/finance/invoices/$invoiceUuid'
    | '/finance/reports/$tabKey'
    | '/finance/transactions/$transactionUuid'
    | '/members/$memberId/$tabKey'
    | '/members/households/$householdUuid'
    | '/organization-settings/billing/$tabKey'
    | '/organization-settings/billing/stripe-complete'
    | '/organization-settings/billing/stripe-refresh'
    | '/organization-settings/general/$tabKey'
    | '/organization-settings/organization-profile/$tabKey'
    | '/invitations/$invitationUuid'
    | '/communication/announcements/'
    | '/communication/templates/'
    | '/events/$eventUuid/'
    | '/finance/donations'
    | '/finance/dues/'
    | '/finance/invoices/'
    | '/finance/orders/'
    | '/finance/reports/'
    | '/finance/transactions/'
    | '/members/$memberId'
    | '/members/groups-committees/'
    | '/members/households/'
    | '/organization-settings/billing'
    | '/organization-settings/general'
    | '/organization-settings/organization-profile'
    | '/organization-settings/roles-permissions'
    | '/communication/announcements/$announcementUuid/$tabKey'
    | '/communication/announcements/$announcementUuid/edit'
    | '/finance/donations/pages/$pageUuid'
    | '/finance/donations/pages/create'
    | '/finance/donations/records/$donationUuid'
    | '/finance/invoices/$invoiceUuid/edit'
    | '/members/groups-committees/$groupUuid/$tabKey'
    | '/organization-settings/roles-permissions/$roleUuid/$tabKey'
    | '/communication/announcements/$announcementUuid/'
    | '/finance/invoices/$invoiceUuid/'
    | '/finance/orders/$orderUuid'
    | '/members/groups-committees/$groupUuid'
    | '/organization-settings/roles-permissions/$roleUuid'
    | '/finance/donations/pages/$pageUuid/edit'
    | '/finance/donations/pages/$pageUuid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authenticate'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/account-settings'
    | '/logout'
    | '/waitlist-welcome'
    | '/account-settings/$tabKey'
    | '/billing/stripe-complete'
    | '/billing/stripe-refresh'
    | '/communication/email-campaigns'
    | '/communication/messages'
    | '/communication/newsletters'
    | '/communication/surveys'
    | '/content/documents'
    | '/content/media'
    | '/content/resources'
    | '/dashboard/calendar'
    | '/dashboard/overview'
    | '/dashboard/recent-activity'
    | '/events/all-events'
    | '/events/attendance'
    | '/events/calendar'
    | '/events/create'
    | '/events/volunteering'
    | '/finance/fundraising'
    | '/finance/overview'
    | '/governance/bylaws'
    | '/governance/elections'
    | '/governance/voting'
    | '/import-result/$uuid'
    | '/members/directory'
    | '/members/invites'
    | '/members/membership-tiers'
    | '/organization-settings/confirm'
    | '/organization-settings/integrations'
    | '/organizations/create'
    | '/communication'
    | '/content'
    | '/dashboard'
    | '/events'
    | '/finance'
    | '/governance'
    | '/members'
    | '/organization-settings'
    | '/organizations'
    | '/account-settings/profile/edit'
    | '/account-settings/security/activity-log'
    | '/account-settings/security/change-email'
    | '/account-settings/security/change-password'
    | '/account-settings/security/mfa-method'
    | '/account-settings/security/mfa-setup'
    | '/account-settings/security/passkey-management'
    | '/account-settings/security/phone-verification'
    | '/account-settings/security/social-link-callback'
    | '/account-settings/security/trusted-devices'
    | '/communication/announcements/new'
    | '/communication/templates/$templateUuid'
    | '/communication/templates/new'
    | '/events/$eventUuid/$tabKey'
    | '/events/$eventUuid/edit'
    | '/finance/donations/$tabKey'
    | '/finance/donations/pages'
    | '/finance/dues/$tabKey'
    | '/finance/reports/$tabKey'
    | '/finance/transactions/$transactionUuid'
    | '/members/$memberId/$tabKey'
    | '/members/households/$householdUuid'
    | '/organization-settings/billing/$tabKey'
    | '/organization-settings/billing/stripe-complete'
    | '/organization-settings/billing/stripe-refresh'
    | '/organization-settings/general/$tabKey'
    | '/organization-settings/organization-profile/$tabKey'
    | '/invitations/$invitationUuid'
    | '/communication/announcements'
    | '/communication/templates'
    | '/events/$eventUuid'
    | '/finance/donations'
    | '/finance/dues'
    | '/finance/invoices'
    | '/finance/orders'
    | '/finance/reports'
    | '/finance/transactions'
    | '/members/$memberId'
    | '/members/groups-committees'
    | '/members/households'
    | '/organization-settings/billing'
    | '/organization-settings/general'
    | '/organization-settings/organization-profile'
    | '/organization-settings/roles-permissions'
    | '/communication/announcements/$announcementUuid/$tabKey'
    | '/communication/announcements/$announcementUuid/edit'
    | '/finance/donations/pages/create'
    | '/finance/donations/records/$donationUuid'
    | '/finance/invoices/$invoiceUuid/edit'
    | '/members/groups-committees/$groupUuid/$tabKey'
    | '/organization-settings/roles-permissions/$roleUuid/$tabKey'
    | '/communication/announcements/$announcementUuid'
    | '/finance/invoices/$invoiceUuid'
    | '/finance/orders/$orderUuid'
    | '/members/groups-committees/$groupUuid'
    | '/organization-settings/roles-permissions/$roleUuid'
    | '/finance/donations/pages/$pageUuid/edit'
    | '/finance/donations/pages/$pageUuid'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/authenticate'
    | '/_authenticated/_account'
    | '/_authenticated/_organization'
    | '/_authenticated/_organizations'
    | '/_unauthenticated/confirm-email'
    | '/_unauthenticated/forgot-password'
    | '/_unauthenticated/login'
    | '/_unauthenticated/reset-password'
    | '/_unauthenticated/signup'
    | '/_authenticated/_account/account-settings'
    | '/_authenticated/_account/logout'
    | '/_authenticated/_account/waitlist-welcome'
    | '/_authenticated/_organization/organization-settings'
    | '/_authenticated/_account/account-settings/$tabKey'
    | '/_authenticated/_organization/billing/stripe-complete'
    | '/_authenticated/_organization/billing/stripe-refresh'
    | '/_authenticated/_organization/communication/announcements'
    | '/_authenticated/_organization/communication/email-campaigns'
    | '/_authenticated/_organization/communication/messages'
    | '/_authenticated/_organization/communication/newsletters'
    | '/_authenticated/_organization/communication/surveys'
    | '/_authenticated/_organization/communication/templates'
    | '/_authenticated/_organization/content/documents'
    | '/_authenticated/_organization/content/media'
    | '/_authenticated/_organization/content/resources'
    | '/_authenticated/_organization/dashboard/calendar'
    | '/_authenticated/_organization/dashboard/overview'
    | '/_authenticated/_organization/dashboard/recent-activity'
    | '/_authenticated/_organization/events/$eventUuid'
    | '/_authenticated/_organization/events/all-events'
    | '/_authenticated/_organization/events/attendance'
    | '/_authenticated/_organization/events/calendar'
    | '/_authenticated/_organization/events/create'
    | '/_authenticated/_organization/events/volunteering'
    | '/_authenticated/_organization/finance/dues'
    | '/_authenticated/_organization/finance/fundraising'
    | '/_authenticated/_organization/finance/invoices'
    | '/_authenticated/_organization/finance/orders'
    | '/_authenticated/_organization/finance/overview'
    | '/_authenticated/_organization/finance/reports'
    | '/_authenticated/_organization/finance/transactions'
    | '/_authenticated/_organization/governance/bylaws'
    | '/_authenticated/_organization/governance/elections'
    | '/_authenticated/_organization/governance/voting'
    | '/_authenticated/_organization/import-result/$uuid'
    | '/_authenticated/_organization/members/directory'
    | '/_authenticated/_organization/members/groups-committees'
    | '/_authenticated/_organization/members/households'
    | '/_authenticated/_organization/members/invites'
    | '/_authenticated/_organization/members/membership-tiers'
    | '/_authenticated/_organization/organization-settings/confirm'
    | '/_authenticated/_organization/organization-settings/integrations'
    | '/_authenticated/_organizations/organizations/create'
    | '/_authenticated/_organization/communication/'
    | '/_authenticated/_organization/content/'
    | '/_authenticated/_organization/dashboard/'
    | '/_authenticated/_organization/events/'
    | '/_authenticated/_organization/finance/'
    | '/_authenticated/_organization/governance/'
    | '/_authenticated/_organization/members/'
    | '/_authenticated/_organization/organization-settings/'
    | '/_authenticated/_organizations/organizations/'
    | '/_authenticated/_account/account-settings/profile/edit'
    | '/_authenticated/_account/account-settings/security/activity-log'
    | '/_authenticated/_account/account-settings/security/change-email'
    | '/_authenticated/_account/account-settings/security/change-password'
    | '/_authenticated/_account/account-settings/security/mfa-method'
    | '/_authenticated/_account/account-settings/security/mfa-setup'
    | '/_authenticated/_account/account-settings/security/passkey-management'
    | '/_authenticated/_account/account-settings/security/phone-verification'
    | '/_authenticated/_account/account-settings/security/social-link-callback'
    | '/_authenticated/_account/account-settings/security/trusted-devices'
    | '/_authenticated/_organization/communication/announcements/$announcementUuid'
    | '/_authenticated/_organization/communication/announcements/new'
    | '/_authenticated/_organization/communication/templates/$templateUuid'
    | '/_authenticated/_organization/communication/templates/new'
    | '/_authenticated/_organization/events/$eventUuid/$tabKey'
    | '/_authenticated/_organization/events/$eventUuid/edit'
    | '/_authenticated/_organization/finance/donations/$tabKey'
    | '/_authenticated/_organization/finance/donations/pages'
    | '/_authenticated/_organization/finance/dues/$tabKey'
    | '/_authenticated/_organization/finance/invoices/$invoiceUuid'
    | '/_authenticated/_organization/finance/reports/$tabKey'
    | '/_authenticated/_organization/finance/transactions/$transactionUuid'
    | '/_authenticated/_organization/members/$memberId/$tabKey'
    | '/_authenticated/_organization/members/households/$householdUuid'
    | '/_authenticated/_organization/organization-settings/billing/$tabKey'
    | '/_authenticated/_organization/organization-settings/billing/stripe-complete'
    | '/_authenticated/_organization/organization-settings/billing/stripe-refresh'
    | '/_authenticated/_organization/organization-settings/general/$tabKey'
    | '/_authenticated/_organization/organization-settings/organization-profile/$tabKey'
    | '/_authenticated/_account/invitations/$invitationUuid/'
    | '/_authenticated/_organization/communication/announcements/'
    | '/_authenticated/_organization/communication/templates/'
    | '/_authenticated/_organization/events/$eventUuid/'
    | '/_authenticated/_organization/finance/donations/'
    | '/_authenticated/_organization/finance/dues/'
    | '/_authenticated/_organization/finance/invoices/'
    | '/_authenticated/_organization/finance/orders/'
    | '/_authenticated/_organization/finance/reports/'
    | '/_authenticated/_organization/finance/transactions/'
    | '/_authenticated/_organization/members/$memberId/'
    | '/_authenticated/_organization/members/groups-committees/'
    | '/_authenticated/_organization/members/households/'
    | '/_authenticated/_organization/organization-settings/billing/'
    | '/_authenticated/_organization/organization-settings/general/'
    | '/_authenticated/_organization/organization-settings/organization-profile/'
    | '/_authenticated/_organization/organization-settings/roles-permissions/'
    | '/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey'
    | '/_authenticated/_organization/communication/announcements/$announcementUuid/edit'
    | '/_authenticated/_organization/finance/donations/pages/$pageUuid'
    | '/_authenticated/_organization/finance/donations/pages/create'
    | '/_authenticated/_organization/finance/donations/records/$donationUuid'
    | '/_authenticated/_organization/finance/invoices/$invoiceUuid/edit'
    | '/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey'
    | '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey'
    | '/_authenticated/_organization/communication/announcements/$announcementUuid/'
    | '/_authenticated/_organization/finance/invoices/$invoiceUuid/'
    | '/_authenticated/_organization/finance/orders/$orderUuid/'
    | '/_authenticated/_organization/members/groups-committees/$groupUuid/'
    | '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/'
    | '/_authenticated/_organization/finance/donations/pages/$pageUuid/edit'
    | '/_authenticated/_organization/finance/donations/pages/$pageUuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  AuthenticateRoute: typeof AuthenticateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/authenticate': {
      id: '/authenticate'
      path: '/authenticate'
      fullPath: '/authenticate'
      preLoaderRoute: typeof AuthenticateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/signup': {
      id: '/_unauthenticated/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthenticatedSignupRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset-password': {
      id: '/_unauthenticated/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthenticatedResetPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/confirm-email': {
      id: '/_unauthenticated/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof UnauthenticatedConfirmEmailRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/_organizations': {
      id: '/_authenticated/_organizations'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_organization': {
      id: '/_authenticated/_organization'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_account': {
      id: '/_authenticated/_account'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_organization/organization-settings': {
      id: '/_authenticated/_organization/organization-settings'
      path: '/organization-settings'
      fullPath: '/organization-settings'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_account/waitlist-welcome': {
      id: '/_authenticated/_account/waitlist-welcome'
      path: '/waitlist-welcome'
      fullPath: '/waitlist-welcome'
      preLoaderRoute: typeof AuthenticatedAccountWaitlistWelcomeRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/_account/logout': {
      id: '/_authenticated/_account/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedAccountLogoutRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/_account/account-settings': {
      id: '/_authenticated/_account/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/_organizations/organizations/': {
      id: '/_authenticated/_organizations/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRoute
    }
    '/_authenticated/_organization/organization-settings/': {
      id: '/_authenticated/_organization/organization-settings/'
      path: '/'
      fullPath: '/organization-settings/'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/': {
      id: '/_authenticated/_organization/members/'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/governance/': {
      id: '/_authenticated/_organization/governance/'
      path: '/governance'
      fullPath: '/governance'
      preLoaderRoute: typeof AuthenticatedOrganizationGovernanceIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/': {
      id: '/_authenticated/_organization/finance/'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/': {
      id: '/_authenticated/_organization/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/dashboard/': {
      id: '/_authenticated/_organization/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedOrganizationDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/content/': {
      id: '/_authenticated/_organization/content/'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof AuthenticatedOrganizationContentIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/': {
      id: '/_authenticated/_organization/communication/'
      path: '/communication'
      fullPath: '/communication'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organizations/organizations/create': {
      id: '/_authenticated/_organizations/organizations/create'
      path: '/organizations/create'
      fullPath: '/organizations/create'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationsCreateRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRoute
    }
    '/_authenticated/_organization/organization-settings/integrations': {
      id: '/_authenticated/_organization/organization-settings/integrations'
      path: '/integrations'
      fullPath: '/organization-settings/integrations'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/confirm': {
      id: '/_authenticated/_organization/organization-settings/confirm'
      path: '/confirm'
      fullPath: '/organization-settings/confirm'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsConfirmRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/membership-tiers': {
      id: '/_authenticated/_organization/members/membership-tiers'
      path: '/members/membership-tiers'
      fullPath: '/members/membership-tiers'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersMembershipTiersRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/members/invites': {
      id: '/_authenticated/_organization/members/invites'
      path: '/members/invites'
      fullPath: '/members/invites'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersInvitesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/members/households': {
      id: '/_authenticated/_organization/members/households'
      path: '/members/households'
      fullPath: '/members/households'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersHouseholdsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/members/groups-committees': {
      id: '/_authenticated/_organization/members/groups-committees'
      path: '/members/groups-committees'
      fullPath: '/members/groups-committees'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/members/directory': {
      id: '/_authenticated/_organization/members/directory'
      path: '/members/directory'
      fullPath: '/members/directory'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersDirectoryRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/import-result/$uuid': {
      id: '/_authenticated/_organization/import-result/$uuid'
      path: '/import-result/$uuid'
      fullPath: '/import-result/$uuid'
      preLoaderRoute: typeof AuthenticatedOrganizationImportResultUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/governance/voting': {
      id: '/_authenticated/_organization/governance/voting'
      path: '/governance/voting'
      fullPath: '/governance/voting'
      preLoaderRoute: typeof AuthenticatedOrganizationGovernanceVotingRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/governance/elections': {
      id: '/_authenticated/_organization/governance/elections'
      path: '/governance/elections'
      fullPath: '/governance/elections'
      preLoaderRoute: typeof AuthenticatedOrganizationGovernanceElectionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/governance/bylaws': {
      id: '/_authenticated/_organization/governance/bylaws'
      path: '/governance/bylaws'
      fullPath: '/governance/bylaws'
      preLoaderRoute: typeof AuthenticatedOrganizationGovernanceBylawsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/transactions': {
      id: '/_authenticated/_organization/finance/transactions'
      path: '/finance/transactions'
      fullPath: '/finance/transactions'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceTransactionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/reports': {
      id: '/_authenticated/_organization/finance/reports'
      path: '/finance/reports'
      fullPath: '/finance/reports'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceReportsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/overview': {
      id: '/_authenticated/_organization/finance/overview'
      path: '/finance/overview'
      fullPath: '/finance/overview'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceOverviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/orders': {
      id: '/_authenticated/_organization/finance/orders'
      path: '/finance/orders'
      fullPath: '/finance/orders'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceOrdersRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/invoices': {
      id: '/_authenticated/_organization/finance/invoices'
      path: '/finance/invoices'
      fullPath: '/finance/invoices'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceInvoicesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/fundraising': {
      id: '/_authenticated/_organization/finance/fundraising'
      path: '/finance/fundraising'
      fullPath: '/finance/fundraising'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceFundraisingRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/dues': {
      id: '/_authenticated/_organization/finance/dues'
      path: '/finance/dues'
      fullPath: '/finance/dues'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDuesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/volunteering': {
      id: '/_authenticated/_organization/events/volunteering'
      path: '/events/volunteering'
      fullPath: '/events/volunteering'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsVolunteeringRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/create': {
      id: '/_authenticated/_organization/events/create'
      path: '/events/create'
      fullPath: '/events/create'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsCreateRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/calendar': {
      id: '/_authenticated/_organization/events/calendar'
      path: '/events/calendar'
      fullPath: '/events/calendar'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsCalendarRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/attendance': {
      id: '/_authenticated/_organization/events/attendance'
      path: '/events/attendance'
      fullPath: '/events/attendance'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsAttendanceRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/all-events': {
      id: '/_authenticated/_organization/events/all-events'
      path: '/events/all-events'
      fullPath: '/events/all-events'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsAllEventsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/$eventUuid': {
      id: '/_authenticated/_organization/events/$eventUuid'
      path: '/events/$eventUuid'
      fullPath: '/events/$eventUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsEventUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/dashboard/recent-activity': {
      id: '/_authenticated/_organization/dashboard/recent-activity'
      path: '/dashboard/recent-activity'
      fullPath: '/dashboard/recent-activity'
      preLoaderRoute: typeof AuthenticatedOrganizationDashboardRecentActivityRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/dashboard/overview': {
      id: '/_authenticated/_organization/dashboard/overview'
      path: '/dashboard/overview'
      fullPath: '/dashboard/overview'
      preLoaderRoute: typeof AuthenticatedOrganizationDashboardOverviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/dashboard/calendar': {
      id: '/_authenticated/_organization/dashboard/calendar'
      path: '/dashboard/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof AuthenticatedOrganizationDashboardCalendarRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/content/resources': {
      id: '/_authenticated/_organization/content/resources'
      path: '/content/resources'
      fullPath: '/content/resources'
      preLoaderRoute: typeof AuthenticatedOrganizationContentResourcesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/content/media': {
      id: '/_authenticated/_organization/content/media'
      path: '/content/media'
      fullPath: '/content/media'
      preLoaderRoute: typeof AuthenticatedOrganizationContentMediaRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/content/documents': {
      id: '/_authenticated/_organization/content/documents'
      path: '/content/documents'
      fullPath: '/content/documents'
      preLoaderRoute: typeof AuthenticatedOrganizationContentDocumentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/templates': {
      id: '/_authenticated/_organization/communication/templates'
      path: '/communication/templates'
      fullPath: '/communication/templates'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationTemplatesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/surveys': {
      id: '/_authenticated/_organization/communication/surveys'
      path: '/communication/surveys'
      fullPath: '/communication/surveys'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationSurveysRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/newsletters': {
      id: '/_authenticated/_organization/communication/newsletters'
      path: '/communication/newsletters'
      fullPath: '/communication/newsletters'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationNewslettersRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/messages': {
      id: '/_authenticated/_organization/communication/messages'
      path: '/communication/messages'
      fullPath: '/communication/messages'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationMessagesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/email-campaigns': {
      id: '/_authenticated/_organization/communication/email-campaigns'
      path: '/communication/email-campaigns'
      fullPath: '/communication/email-campaigns'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationEmailCampaignsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/communication/announcements': {
      id: '/_authenticated/_organization/communication/announcements'
      path: '/communication/announcements'
      fullPath: '/communication/announcements'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/billing/stripe-refresh': {
      id: '/_authenticated/_organization/billing/stripe-refresh'
      path: '/billing/stripe-refresh'
      fullPath: '/billing/stripe-refresh'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingStripeRefreshRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/billing/stripe-complete': {
      id: '/_authenticated/_organization/billing/stripe-complete'
      path: '/billing/stripe-complete'
      fullPath: '/billing/stripe-complete'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingStripeCompleteRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_account/account-settings/$tabKey': {
      id: '/_authenticated/_account/account-settings/$tabKey'
      path: '/$tabKey'
      fullPath: '/account-settings/$tabKey'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsTabKeyRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/roles-permissions/': {
      id: '/_authenticated/_organization/organization-settings/roles-permissions/'
      path: '/roles-permissions'
      fullPath: '/organization-settings/roles-permissions'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/organization-profile/': {
      id: '/_authenticated/_organization/organization-settings/organization-profile/'
      path: '/organization-profile'
      fullPath: '/organization-settings/organization-profile'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/general/': {
      id: '/_authenticated/_organization/organization-settings/general/'
      path: '/general'
      fullPath: '/organization-settings/general'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsGeneralIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/billing/': {
      id: '/_authenticated/_organization/organization-settings/billing/'
      path: '/billing'
      fullPath: '/organization-settings/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/households/': {
      id: '/_authenticated/_organization/members/households/'
      path: '/'
      fullPath: '/members/households/'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersHouseholdsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationMembersHouseholdsRoute
    }
    '/_authenticated/_organization/members/groups-committees/': {
      id: '/_authenticated/_organization/members/groups-committees/'
      path: '/'
      fullPath: '/members/groups-committees/'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesRoute
    }
    '/_authenticated/_organization/members/$memberId/': {
      id: '/_authenticated/_organization/members/$memberId/'
      path: '/members/$memberId'
      fullPath: '/members/$memberId'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersMemberIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/transactions/': {
      id: '/_authenticated/_organization/finance/transactions/'
      path: '/'
      fullPath: '/finance/transactions/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceTransactionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceTransactionsRoute
    }
    '/_authenticated/_organization/finance/reports/': {
      id: '/_authenticated/_organization/finance/reports/'
      path: '/'
      fullPath: '/finance/reports/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceReportsRoute
    }
    '/_authenticated/_organization/finance/orders/': {
      id: '/_authenticated/_organization/finance/orders/'
      path: '/'
      fullPath: '/finance/orders/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceOrdersRoute
    }
    '/_authenticated/_organization/finance/invoices/': {
      id: '/_authenticated/_organization/finance/invoices/'
      path: '/'
      fullPath: '/finance/invoices/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceInvoicesRoute
    }
    '/_authenticated/_organization/finance/dues/': {
      id: '/_authenticated/_organization/finance/dues/'
      path: '/'
      fullPath: '/finance/dues/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDuesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDuesRoute
    }
    '/_authenticated/_organization/finance/donations/': {
      id: '/_authenticated/_organization/finance/donations/'
      path: '/finance/donations'
      fullPath: '/finance/donations'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/$eventUuid/': {
      id: '/_authenticated/_organization/events/$eventUuid/'
      path: '/'
      fullPath: '/events/$eventUuid/'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsEventUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationEventsEventUuidRoute
    }
    '/_authenticated/_organization/communication/templates/': {
      id: '/_authenticated/_organization/communication/templates/'
      path: '/'
      fullPath: '/communication/templates/'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationTemplatesRoute
    }
    '/_authenticated/_organization/communication/announcements/': {
      id: '/_authenticated/_organization/communication/announcements/'
      path: '/'
      fullPath: '/communication/announcements/'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsRoute
    }
    '/_authenticated/_account/invitations/$invitationUuid/': {
      id: '/_authenticated/_account/invitations/$invitationUuid/'
      path: '/invitations/$invitationUuid'
      fullPath: '/invitations/$invitationUuid'
      preLoaderRoute: typeof AuthenticatedAccountInvitationsInvitationUuidIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/_organization/organization-settings/organization-profile/$tabKey': {
      id: '/_authenticated/_organization/organization-settings/organization-profile/$tabKey'
      path: '/organization-profile/$tabKey'
      fullPath: '/organization-settings/organization-profile/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/general/$tabKey': {
      id: '/_authenticated/_organization/organization-settings/general/$tabKey'
      path: '/general/$tabKey'
      fullPath: '/organization-settings/general/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/billing/stripe-refresh': {
      id: '/_authenticated/_organization/organization-settings/billing/stripe-refresh'
      path: '/billing/stripe-refresh'
      fullPath: '/organization-settings/billing/stripe-refresh'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/billing/stripe-complete': {
      id: '/_authenticated/_organization/organization-settings/billing/stripe-complete'
      path: '/billing/stripe-complete'
      fullPath: '/organization-settings/billing/stripe-complete'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/billing/$tabKey': {
      id: '/_authenticated/_organization/organization-settings/billing/$tabKey'
      path: '/billing/$tabKey'
      fullPath: '/organization-settings/billing/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/households/$householdUuid': {
      id: '/_authenticated/_organization/members/households/$householdUuid'
      path: '/$householdUuid'
      fullPath: '/members/households/$householdUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationMembersHouseholdsRoute
    }
    '/_authenticated/_organization/members/$memberId/$tabKey': {
      id: '/_authenticated/_organization/members/$memberId/$tabKey'
      path: '/members/$memberId/$tabKey'
      fullPath: '/members/$memberId/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersMemberIdTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/transactions/$transactionUuid': {
      id: '/_authenticated/_organization/finance/transactions/$transactionUuid'
      path: '/$transactionUuid'
      fullPath: '/finance/transactions/$transactionUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceTransactionsTransactionUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceTransactionsRoute
    }
    '/_authenticated/_organization/finance/reports/$tabKey': {
      id: '/_authenticated/_organization/finance/reports/$tabKey'
      path: '/$tabKey'
      fullPath: '/finance/reports/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceReportsTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceReportsRoute
    }
    '/_authenticated/_organization/finance/invoices/$invoiceUuid': {
      id: '/_authenticated/_organization/finance/invoices/$invoiceUuid'
      path: '/$invoiceUuid'
      fullPath: '/finance/invoices/$invoiceUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceInvoicesRoute
    }
    '/_authenticated/_organization/finance/dues/$tabKey': {
      id: '/_authenticated/_organization/finance/dues/$tabKey'
      path: '/$tabKey'
      fullPath: '/finance/dues/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDuesTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDuesRoute
    }
    '/_authenticated/_organization/finance/donations/pages': {
      id: '/_authenticated/_organization/finance/donations/pages'
      path: '/finance/donations/pages'
      fullPath: '/finance/donations/pages'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/donations/$tabKey': {
      id: '/_authenticated/_organization/finance/donations/$tabKey'
      path: '/finance/donations/$tabKey'
      fullPath: '/finance/donations/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/events/$eventUuid/edit': {
      id: '/_authenticated/_organization/events/$eventUuid/edit'
      path: '/edit'
      fullPath: '/events/$eventUuid/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsEventUuidEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationEventsEventUuidRoute
    }
    '/_authenticated/_organization/events/$eventUuid/$tabKey': {
      id: '/_authenticated/_organization/events/$eventUuid/$tabKey'
      path: '/$tabKey'
      fullPath: '/events/$eventUuid/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationEventsEventUuidTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationEventsEventUuidRoute
    }
    '/_authenticated/_organization/communication/templates/new': {
      id: '/_authenticated/_organization/communication/templates/new'
      path: '/new'
      fullPath: '/communication/templates/new'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationTemplatesRoute
    }
    '/_authenticated/_organization/communication/templates/$templateUuid': {
      id: '/_authenticated/_organization/communication/templates/$templateUuid'
      path: '/$templateUuid'
      fullPath: '/communication/templates/$templateUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationTemplatesRoute
    }
    '/_authenticated/_organization/communication/announcements/new': {
      id: '/_authenticated/_organization/communication/announcements/new'
      path: '/new'
      fullPath: '/communication/announcements/new'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsNewRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsRoute
    }
    '/_authenticated/_organization/communication/announcements/$announcementUuid': {
      id: '/_authenticated/_organization/communication/announcements/$announcementUuid'
      path: '/$announcementUuid'
      fullPath: '/communication/announcements/$announcementUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsRoute
    }
    '/_authenticated/_account/account-settings/security/trusted-devices': {
      id: '/_authenticated/_account/account-settings/security/trusted-devices'
      path: '/security/trusted-devices'
      fullPath: '/account-settings/security/trusted-devices'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/social-link-callback': {
      id: '/_authenticated/_account/account-settings/security/social-link-callback'
      path: '/security/social-link-callback'
      fullPath: '/account-settings/security/social-link-callback'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/phone-verification': {
      id: '/_authenticated/_account/account-settings/security/phone-verification'
      path: '/security/phone-verification'
      fullPath: '/account-settings/security/phone-verification'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/passkey-management': {
      id: '/_authenticated/_account/account-settings/security/passkey-management'
      path: '/security/passkey-management'
      fullPath: '/account-settings/security/passkey-management'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/mfa-setup': {
      id: '/_authenticated/_account/account-settings/security/mfa-setup'
      path: '/security/mfa-setup'
      fullPath: '/account-settings/security/mfa-setup'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityMfaSetupRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/mfa-method': {
      id: '/_authenticated/_account/account-settings/security/mfa-method'
      path: '/security/mfa-method'
      fullPath: '/account-settings/security/mfa-method'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityMfaMethodRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/change-password': {
      id: '/_authenticated/_account/account-settings/security/change-password'
      path: '/security/change-password'
      fullPath: '/account-settings/security/change-password'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityChangePasswordRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/change-email': {
      id: '/_authenticated/_account/account-settings/security/change-email'
      path: '/security/change-email'
      fullPath: '/account-settings/security/change-email'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityChangeEmailRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/security/activity-log': {
      id: '/_authenticated/_account/account-settings/security/activity-log'
      path: '/security/activity-log'
      fullPath: '/account-settings/security/activity-log'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsSecurityActivityLogRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_account/account-settings/profile/edit': {
      id: '/_authenticated/_account/account-settings/profile/edit'
      path: '/profile/edit'
      fullPath: '/account-settings/profile/edit'
      preLoaderRoute: typeof AuthenticatedAccountAccountSettingsProfileEditRouteImport
      parentRoute: typeof AuthenticatedAccountAccountSettingsRoute
    }
    '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/': {
      id: '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/'
      path: '/roles-permissions/$roleUuid'
      fullPath: '/organization-settings/roles-permissions/$roleUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/groups-committees/$groupUuid/': {
      id: '/_authenticated/_organization/members/groups-committees/$groupUuid/'
      path: '/$groupUuid'
      fullPath: '/members/groups-committees/$groupUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesRoute
    }
    '/_authenticated/_organization/finance/orders/$orderUuid/': {
      id: '/_authenticated/_organization/finance/orders/$orderUuid/'
      path: '/$orderUuid'
      fullPath: '/finance/orders/$orderUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceOrdersRoute
    }
    '/_authenticated/_organization/finance/invoices/$invoiceUuid/': {
      id: '/_authenticated/_organization/finance/invoices/$invoiceUuid/'
      path: '/'
      fullPath: '/finance/invoices/$invoiceUuid/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute
    }
    '/_authenticated/_organization/communication/announcements/$announcementUuid/': {
      id: '/_authenticated/_organization/communication/announcements/$announcementUuid/'
      path: '/'
      fullPath: '/communication/announcements/$announcementUuid/'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute
    }
    '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey': {
      id: '/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey'
      path: '/roles-permissions/$roleUuid/$tabKey'
      fullPath: '/organization-settings/roles-permissions/$roleUuid/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationSettingsRoute
    }
    '/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey': {
      id: '/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey'
      path: '/$groupUuid/$tabKey'
      fullPath: '/members/groups-committees/$groupUuid/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesRoute
    }
    '/_authenticated/_organization/finance/invoices/$invoiceUuid/edit': {
      id: '/_authenticated/_organization/finance/invoices/$invoiceUuid/edit'
      path: '/edit'
      fullPath: '/finance/invoices/$invoiceUuid/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute
    }
    '/_authenticated/_organization/finance/donations/records/$donationUuid': {
      id: '/_authenticated/_organization/finance/donations/records/$donationUuid'
      path: '/finance/donations/records/$donationUuid'
      fullPath: '/finance/donations/records/$donationUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/finance/donations/pages/create': {
      id: '/_authenticated/_organization/finance/donations/pages/create'
      path: '/create'
      fullPath: '/finance/donations/pages/create'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesCreateRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesRoute
    }
    '/_authenticated/_organization/finance/donations/pages/$pageUuid': {
      id: '/_authenticated/_organization/finance/donations/pages/$pageUuid'
      path: '/$pageUuid'
      fullPath: '/finance/donations/pages/$pageUuid'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesRoute
    }
    '/_authenticated/_organization/communication/announcements/$announcementUuid/edit': {
      id: '/_authenticated/_organization/communication/announcements/$announcementUuid/edit'
      path: '/edit'
      fullPath: '/communication/announcements/$announcementUuid/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute
    }
    '/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey': {
      id: '/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey'
      path: '/$tabKey'
      fullPath: '/communication/announcements/$announcementUuid/$tabKey'
      preLoaderRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute
    }
    '/_authenticated/_organization/finance/donations/pages/$pageUuid/': {
      id: '/_authenticated/_organization/finance/donations/pages/$pageUuid/'
      path: '/'
      fullPath: '/finance/donations/pages/$pageUuid/'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute
    }
    '/_authenticated/_organization/finance/donations/pages/$pageUuid/edit': {
      id: '/_authenticated/_organization/finance/donations/pages/$pageUuid/edit'
      path: '/edit'
      fullPath: '/finance/donations/pages/$pageUuid/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute
    }
  }
}

interface AuthenticatedAccountAccountSettingsRouteChildren {
  AuthenticatedAccountAccountSettingsTabKeyRoute: typeof AuthenticatedAccountAccountSettingsTabKeyRoute
  AuthenticatedAccountAccountSettingsProfileEditRoute: typeof AuthenticatedAccountAccountSettingsProfileEditRoute
  AuthenticatedAccountAccountSettingsSecurityActivityLogRoute: typeof AuthenticatedAccountAccountSettingsSecurityActivityLogRoute
  AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute: typeof AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute
  AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute: typeof AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute
  AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute: typeof AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute
  AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute: typeof AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute
  AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute: typeof AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute
  AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute: typeof AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute
  AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute: typeof AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute
  AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute: typeof AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute
}

const AuthenticatedAccountAccountSettingsRouteChildren: AuthenticatedAccountAccountSettingsRouteChildren =
  {
    AuthenticatedAccountAccountSettingsTabKeyRoute:
      AuthenticatedAccountAccountSettingsTabKeyRoute,
    AuthenticatedAccountAccountSettingsProfileEditRoute:
      AuthenticatedAccountAccountSettingsProfileEditRoute,
    AuthenticatedAccountAccountSettingsSecurityActivityLogRoute:
      AuthenticatedAccountAccountSettingsSecurityActivityLogRoute,
    AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute:
      AuthenticatedAccountAccountSettingsSecurityChangeEmailRoute,
    AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute:
      AuthenticatedAccountAccountSettingsSecurityChangePasswordRoute,
    AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute:
      AuthenticatedAccountAccountSettingsSecurityMfaMethodRoute,
    AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute:
      AuthenticatedAccountAccountSettingsSecurityMfaSetupRoute,
    AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute:
      AuthenticatedAccountAccountSettingsSecurityPasskeyManagementRoute,
    AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute:
      AuthenticatedAccountAccountSettingsSecurityPhoneVerificationRoute,
    AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute:
      AuthenticatedAccountAccountSettingsSecuritySocialLinkCallbackRoute,
    AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute:
      AuthenticatedAccountAccountSettingsSecurityTrustedDevicesRoute,
  }

const AuthenticatedAccountAccountSettingsRouteWithChildren =
  AuthenticatedAccountAccountSettingsRoute._addFileChildren(
    AuthenticatedAccountAccountSettingsRouteChildren,
  )

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountAccountSettingsRoute: typeof AuthenticatedAccountAccountSettingsRouteWithChildren
  AuthenticatedAccountLogoutRoute: typeof AuthenticatedAccountLogoutRoute
  AuthenticatedAccountWaitlistWelcomeRoute: typeof AuthenticatedAccountWaitlistWelcomeRoute
  AuthenticatedAccountInvitationsInvitationUuidIndexRoute: typeof AuthenticatedAccountInvitationsInvitationUuidIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountAccountSettingsRoute:
    AuthenticatedAccountAccountSettingsRouteWithChildren,
  AuthenticatedAccountLogoutRoute: AuthenticatedAccountLogoutRoute,
  AuthenticatedAccountWaitlistWelcomeRoute:
    AuthenticatedAccountWaitlistWelcomeRoute,
  AuthenticatedAccountInvitationsInvitationUuidIndexRoute:
    AuthenticatedAccountInvitationsInvitationUuidIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedOrganizationOrganizationSettingsRouteChildren {
  AuthenticatedOrganizationOrganizationSettingsConfirmRoute: typeof AuthenticatedOrganizationOrganizationSettingsConfirmRoute
  AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute: typeof AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute
  AuthenticatedOrganizationOrganizationSettingsIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsIndexRoute
  AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute
  AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute
  AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute
  AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute: typeof AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute
  AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute: typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute
  AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute
  AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute
  AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute
  AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute: typeof AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute
}

const AuthenticatedOrganizationOrganizationSettingsRouteChildren: AuthenticatedOrganizationOrganizationSettingsRouteChildren =
  {
    AuthenticatedOrganizationOrganizationSettingsConfirmRoute:
      AuthenticatedOrganizationOrganizationSettingsConfirmRoute,
    AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute:
      AuthenticatedOrganizationOrganizationSettingsIntegrationsRoute,
    AuthenticatedOrganizationOrganizationSettingsIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsIndexRoute,
    AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute:
      AuthenticatedOrganizationOrganizationSettingsBillingTabKeyRoute,
    AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute:
      AuthenticatedOrganizationOrganizationSettingsBillingStripeCompleteRoute,
    AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute:
      AuthenticatedOrganizationOrganizationSettingsBillingStripeRefreshRoute,
    AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute:
      AuthenticatedOrganizationOrganizationSettingsGeneralTabKeyRoute,
    AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute:
      AuthenticatedOrganizationOrganizationSettingsOrganizationProfileTabKeyRoute,
    AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsBillingIndexRoute,
    AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsGeneralIndexRoute,
    AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsOrganizationProfileIndexRoute,
    AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsRolesPermissionsIndexRoute,
    AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute:
      AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidTabKeyRoute,
    AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute:
      AuthenticatedOrganizationOrganizationSettingsRolesPermissionsRoleUuidIndexRoute,
  }

const AuthenticatedOrganizationOrganizationSettingsRouteWithChildren =
  AuthenticatedOrganizationOrganizationSettingsRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationSettingsRouteChildren,
  )

interface AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteChildren {
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute
}

const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteChildren: AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteChildren =
  {
    AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidTabKeyRoute,
    AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidEditRoute,
    AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidIndexRoute,
  }

const AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteWithChildren =
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute._addFileChildren(
    AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteChildren,
  )

interface AuthenticatedOrganizationCommunicationAnnouncementsRouteChildren {
  AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteWithChildren
  AuthenticatedOrganizationCommunicationAnnouncementsNewRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsNewRoute
  AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute
}

const AuthenticatedOrganizationCommunicationAnnouncementsRouteChildren: AuthenticatedOrganizationCommunicationAnnouncementsRouteChildren =
  {
    AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsAnnouncementUuidRouteWithChildren,
    AuthenticatedOrganizationCommunicationAnnouncementsNewRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsNewRoute,
    AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsIndexRoute,
  }

const AuthenticatedOrganizationCommunicationAnnouncementsRouteWithChildren =
  AuthenticatedOrganizationCommunicationAnnouncementsRoute._addFileChildren(
    AuthenticatedOrganizationCommunicationAnnouncementsRouteChildren,
  )

interface AuthenticatedOrganizationCommunicationTemplatesRouteChildren {
  AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute: typeof AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute
  AuthenticatedOrganizationCommunicationTemplatesNewRoute: typeof AuthenticatedOrganizationCommunicationTemplatesNewRoute
  AuthenticatedOrganizationCommunicationTemplatesIndexRoute: typeof AuthenticatedOrganizationCommunicationTemplatesIndexRoute
}

const AuthenticatedOrganizationCommunicationTemplatesRouteChildren: AuthenticatedOrganizationCommunicationTemplatesRouteChildren =
  {
    AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute:
      AuthenticatedOrganizationCommunicationTemplatesTemplateUuidRoute,
    AuthenticatedOrganizationCommunicationTemplatesNewRoute:
      AuthenticatedOrganizationCommunicationTemplatesNewRoute,
    AuthenticatedOrganizationCommunicationTemplatesIndexRoute:
      AuthenticatedOrganizationCommunicationTemplatesIndexRoute,
  }

const AuthenticatedOrganizationCommunicationTemplatesRouteWithChildren =
  AuthenticatedOrganizationCommunicationTemplatesRoute._addFileChildren(
    AuthenticatedOrganizationCommunicationTemplatesRouteChildren,
  )

interface AuthenticatedOrganizationEventsEventUuidRouteChildren {
  AuthenticatedOrganizationEventsEventUuidTabKeyRoute: typeof AuthenticatedOrganizationEventsEventUuidTabKeyRoute
  AuthenticatedOrganizationEventsEventUuidEditRoute: typeof AuthenticatedOrganizationEventsEventUuidEditRoute
  AuthenticatedOrganizationEventsEventUuidIndexRoute: typeof AuthenticatedOrganizationEventsEventUuidIndexRoute
}

const AuthenticatedOrganizationEventsEventUuidRouteChildren: AuthenticatedOrganizationEventsEventUuidRouteChildren =
  {
    AuthenticatedOrganizationEventsEventUuidTabKeyRoute:
      AuthenticatedOrganizationEventsEventUuidTabKeyRoute,
    AuthenticatedOrganizationEventsEventUuidEditRoute:
      AuthenticatedOrganizationEventsEventUuidEditRoute,
    AuthenticatedOrganizationEventsEventUuidIndexRoute:
      AuthenticatedOrganizationEventsEventUuidIndexRoute,
  }

const AuthenticatedOrganizationEventsEventUuidRouteWithChildren =
  AuthenticatedOrganizationEventsEventUuidRoute._addFileChildren(
    AuthenticatedOrganizationEventsEventUuidRouteChildren,
  )

interface AuthenticatedOrganizationFinanceDuesRouteChildren {
  AuthenticatedOrganizationFinanceDuesTabKeyRoute: typeof AuthenticatedOrganizationFinanceDuesTabKeyRoute
  AuthenticatedOrganizationFinanceDuesIndexRoute: typeof AuthenticatedOrganizationFinanceDuesIndexRoute
}

const AuthenticatedOrganizationFinanceDuesRouteChildren: AuthenticatedOrganizationFinanceDuesRouteChildren =
  {
    AuthenticatedOrganizationFinanceDuesTabKeyRoute:
      AuthenticatedOrganizationFinanceDuesTabKeyRoute,
    AuthenticatedOrganizationFinanceDuesIndexRoute:
      AuthenticatedOrganizationFinanceDuesIndexRoute,
  }

const AuthenticatedOrganizationFinanceDuesRouteWithChildren =
  AuthenticatedOrganizationFinanceDuesRoute._addFileChildren(
    AuthenticatedOrganizationFinanceDuesRouteChildren,
  )

interface AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteChildren {
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute
}

const AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteChildren: AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteChildren =
  {
    AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute:
      AuthenticatedOrganizationFinanceInvoicesInvoiceUuidEditRoute,
    AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute:
      AuthenticatedOrganizationFinanceInvoicesInvoiceUuidIndexRoute,
  }

const AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteWithChildren =
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute._addFileChildren(
    AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteChildren,
  )

interface AuthenticatedOrganizationFinanceInvoicesRouteChildren {
  AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute: typeof AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteWithChildren
  AuthenticatedOrganizationFinanceInvoicesIndexRoute: typeof AuthenticatedOrganizationFinanceInvoicesIndexRoute
}

const AuthenticatedOrganizationFinanceInvoicesRouteChildren: AuthenticatedOrganizationFinanceInvoicesRouteChildren =
  {
    AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRoute:
      AuthenticatedOrganizationFinanceInvoicesInvoiceUuidRouteWithChildren,
    AuthenticatedOrganizationFinanceInvoicesIndexRoute:
      AuthenticatedOrganizationFinanceInvoicesIndexRoute,
  }

const AuthenticatedOrganizationFinanceInvoicesRouteWithChildren =
  AuthenticatedOrganizationFinanceInvoicesRoute._addFileChildren(
    AuthenticatedOrganizationFinanceInvoicesRouteChildren,
  )

interface AuthenticatedOrganizationFinanceOrdersRouteChildren {
  AuthenticatedOrganizationFinanceOrdersIndexRoute: typeof AuthenticatedOrganizationFinanceOrdersIndexRoute
  AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute: typeof AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute
}

const AuthenticatedOrganizationFinanceOrdersRouteChildren: AuthenticatedOrganizationFinanceOrdersRouteChildren =
  {
    AuthenticatedOrganizationFinanceOrdersIndexRoute:
      AuthenticatedOrganizationFinanceOrdersIndexRoute,
    AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute:
      AuthenticatedOrganizationFinanceOrdersOrderUuidIndexRoute,
  }

const AuthenticatedOrganizationFinanceOrdersRouteWithChildren =
  AuthenticatedOrganizationFinanceOrdersRoute._addFileChildren(
    AuthenticatedOrganizationFinanceOrdersRouteChildren,
  )

interface AuthenticatedOrganizationFinanceReportsRouteChildren {
  AuthenticatedOrganizationFinanceReportsTabKeyRoute: typeof AuthenticatedOrganizationFinanceReportsTabKeyRoute
  AuthenticatedOrganizationFinanceReportsIndexRoute: typeof AuthenticatedOrganizationFinanceReportsIndexRoute
}

const AuthenticatedOrganizationFinanceReportsRouteChildren: AuthenticatedOrganizationFinanceReportsRouteChildren =
  {
    AuthenticatedOrganizationFinanceReportsTabKeyRoute:
      AuthenticatedOrganizationFinanceReportsTabKeyRoute,
    AuthenticatedOrganizationFinanceReportsIndexRoute:
      AuthenticatedOrganizationFinanceReportsIndexRoute,
  }

const AuthenticatedOrganizationFinanceReportsRouteWithChildren =
  AuthenticatedOrganizationFinanceReportsRoute._addFileChildren(
    AuthenticatedOrganizationFinanceReportsRouteChildren,
  )

interface AuthenticatedOrganizationFinanceTransactionsRouteChildren {
  AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute: typeof AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute
  AuthenticatedOrganizationFinanceTransactionsIndexRoute: typeof AuthenticatedOrganizationFinanceTransactionsIndexRoute
}

const AuthenticatedOrganizationFinanceTransactionsRouteChildren: AuthenticatedOrganizationFinanceTransactionsRouteChildren =
  {
    AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute:
      AuthenticatedOrganizationFinanceTransactionsTransactionUuidRoute,
    AuthenticatedOrganizationFinanceTransactionsIndexRoute:
      AuthenticatedOrganizationFinanceTransactionsIndexRoute,
  }

const AuthenticatedOrganizationFinanceTransactionsRouteWithChildren =
  AuthenticatedOrganizationFinanceTransactionsRoute._addFileChildren(
    AuthenticatedOrganizationFinanceTransactionsRouteChildren,
  )

interface AuthenticatedOrganizationMembersGroupsCommitteesRouteChildren {
  AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute
  AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute
  AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute
}

const AuthenticatedOrganizationMembersGroupsCommitteesRouteChildren: AuthenticatedOrganizationMembersGroupsCommitteesRouteChildren =
  {
    AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute:
      AuthenticatedOrganizationMembersGroupsCommitteesIndexRoute,
    AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute:
      AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidTabKeyRoute,
    AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute:
      AuthenticatedOrganizationMembersGroupsCommitteesGroupUuidIndexRoute,
  }

const AuthenticatedOrganizationMembersGroupsCommitteesRouteWithChildren =
  AuthenticatedOrganizationMembersGroupsCommitteesRoute._addFileChildren(
    AuthenticatedOrganizationMembersGroupsCommitteesRouteChildren,
  )

interface AuthenticatedOrganizationMembersHouseholdsRouteChildren {
  AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute: typeof AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute
  AuthenticatedOrganizationMembersHouseholdsIndexRoute: typeof AuthenticatedOrganizationMembersHouseholdsIndexRoute
}

const AuthenticatedOrganizationMembersHouseholdsRouteChildren: AuthenticatedOrganizationMembersHouseholdsRouteChildren =
  {
    AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute:
      AuthenticatedOrganizationMembersHouseholdsHouseholdUuidRoute,
    AuthenticatedOrganizationMembersHouseholdsIndexRoute:
      AuthenticatedOrganizationMembersHouseholdsIndexRoute,
  }

const AuthenticatedOrganizationMembersHouseholdsRouteWithChildren =
  AuthenticatedOrganizationMembersHouseholdsRoute._addFileChildren(
    AuthenticatedOrganizationMembersHouseholdsRouteChildren,
  )

interface AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteChildren {
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute
}

const AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteChildren: AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteChildren =
  {
    AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute:
      AuthenticatedOrganizationFinanceDonationsPagesPageUuidEditRoute,
    AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute:
      AuthenticatedOrganizationFinanceDonationsPagesPageUuidIndexRoute,
  }

const AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteWithChildren =
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute._addFileChildren(
    AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteChildren,
  )

interface AuthenticatedOrganizationFinanceDonationsPagesRouteChildren {
  AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteWithChildren
  AuthenticatedOrganizationFinanceDonationsPagesCreateRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesCreateRoute
}

const AuthenticatedOrganizationFinanceDonationsPagesRouteChildren: AuthenticatedOrganizationFinanceDonationsPagesRouteChildren =
  {
    AuthenticatedOrganizationFinanceDonationsPagesPageUuidRoute:
      AuthenticatedOrganizationFinanceDonationsPagesPageUuidRouteWithChildren,
    AuthenticatedOrganizationFinanceDonationsPagesCreateRoute:
      AuthenticatedOrganizationFinanceDonationsPagesCreateRoute,
  }

const AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren =
  AuthenticatedOrganizationFinanceDonationsPagesRoute._addFileChildren(
    AuthenticatedOrganizationFinanceDonationsPagesRouteChildren,
  )

interface AuthenticatedOrganizationRouteChildren {
  AuthenticatedOrganizationOrganizationSettingsRoute: typeof AuthenticatedOrganizationOrganizationSettingsRouteWithChildren
  AuthenticatedOrganizationBillingStripeCompleteRoute: typeof AuthenticatedOrganizationBillingStripeCompleteRoute
  AuthenticatedOrganizationBillingStripeRefreshRoute: typeof AuthenticatedOrganizationBillingStripeRefreshRoute
  AuthenticatedOrganizationCommunicationAnnouncementsRoute: typeof AuthenticatedOrganizationCommunicationAnnouncementsRouteWithChildren
  AuthenticatedOrganizationCommunicationEmailCampaignsRoute: typeof AuthenticatedOrganizationCommunicationEmailCampaignsRoute
  AuthenticatedOrganizationCommunicationMessagesRoute: typeof AuthenticatedOrganizationCommunicationMessagesRoute
  AuthenticatedOrganizationCommunicationNewslettersRoute: typeof AuthenticatedOrganizationCommunicationNewslettersRoute
  AuthenticatedOrganizationCommunicationSurveysRoute: typeof AuthenticatedOrganizationCommunicationSurveysRoute
  AuthenticatedOrganizationCommunicationTemplatesRoute: typeof AuthenticatedOrganizationCommunicationTemplatesRouteWithChildren
  AuthenticatedOrganizationContentDocumentsRoute: typeof AuthenticatedOrganizationContentDocumentsRoute
  AuthenticatedOrganizationContentMediaRoute: typeof AuthenticatedOrganizationContentMediaRoute
  AuthenticatedOrganizationContentResourcesRoute: typeof AuthenticatedOrganizationContentResourcesRoute
  AuthenticatedOrganizationDashboardCalendarRoute: typeof AuthenticatedOrganizationDashboardCalendarRoute
  AuthenticatedOrganizationDashboardOverviewRoute: typeof AuthenticatedOrganizationDashboardOverviewRoute
  AuthenticatedOrganizationDashboardRecentActivityRoute: typeof AuthenticatedOrganizationDashboardRecentActivityRoute
  AuthenticatedOrganizationEventsEventUuidRoute: typeof AuthenticatedOrganizationEventsEventUuidRouteWithChildren
  AuthenticatedOrganizationEventsAllEventsRoute: typeof AuthenticatedOrganizationEventsAllEventsRoute
  AuthenticatedOrganizationEventsAttendanceRoute: typeof AuthenticatedOrganizationEventsAttendanceRoute
  AuthenticatedOrganizationEventsCalendarRoute: typeof AuthenticatedOrganizationEventsCalendarRoute
  AuthenticatedOrganizationEventsCreateRoute: typeof AuthenticatedOrganizationEventsCreateRoute
  AuthenticatedOrganizationEventsVolunteeringRoute: typeof AuthenticatedOrganizationEventsVolunteeringRoute
  AuthenticatedOrganizationFinanceDuesRoute: typeof AuthenticatedOrganizationFinanceDuesRouteWithChildren
  AuthenticatedOrganizationFinanceFundraisingRoute: typeof AuthenticatedOrganizationFinanceFundraisingRoute
  AuthenticatedOrganizationFinanceInvoicesRoute: typeof AuthenticatedOrganizationFinanceInvoicesRouteWithChildren
  AuthenticatedOrganizationFinanceOrdersRoute: typeof AuthenticatedOrganizationFinanceOrdersRouteWithChildren
  AuthenticatedOrganizationFinanceOverviewRoute: typeof AuthenticatedOrganizationFinanceOverviewRoute
  AuthenticatedOrganizationFinanceReportsRoute: typeof AuthenticatedOrganizationFinanceReportsRouteWithChildren
  AuthenticatedOrganizationFinanceTransactionsRoute: typeof AuthenticatedOrganizationFinanceTransactionsRouteWithChildren
  AuthenticatedOrganizationGovernanceBylawsRoute: typeof AuthenticatedOrganizationGovernanceBylawsRoute
  AuthenticatedOrganizationGovernanceElectionsRoute: typeof AuthenticatedOrganizationGovernanceElectionsRoute
  AuthenticatedOrganizationGovernanceVotingRoute: typeof AuthenticatedOrganizationGovernanceVotingRoute
  AuthenticatedOrganizationImportResultUuidRoute: typeof AuthenticatedOrganizationImportResultUuidRoute
  AuthenticatedOrganizationMembersDirectoryRoute: typeof AuthenticatedOrganizationMembersDirectoryRoute
  AuthenticatedOrganizationMembersGroupsCommitteesRoute: typeof AuthenticatedOrganizationMembersGroupsCommitteesRouteWithChildren
  AuthenticatedOrganizationMembersHouseholdsRoute: typeof AuthenticatedOrganizationMembersHouseholdsRouteWithChildren
  AuthenticatedOrganizationMembersInvitesRoute: typeof AuthenticatedOrganizationMembersInvitesRoute
  AuthenticatedOrganizationMembersMembershipTiersRoute: typeof AuthenticatedOrganizationMembersMembershipTiersRoute
  AuthenticatedOrganizationCommunicationIndexRoute: typeof AuthenticatedOrganizationCommunicationIndexRoute
  AuthenticatedOrganizationContentIndexRoute: typeof AuthenticatedOrganizationContentIndexRoute
  AuthenticatedOrganizationDashboardIndexRoute: typeof AuthenticatedOrganizationDashboardIndexRoute
  AuthenticatedOrganizationEventsIndexRoute: typeof AuthenticatedOrganizationEventsIndexRoute
  AuthenticatedOrganizationFinanceIndexRoute: typeof AuthenticatedOrganizationFinanceIndexRoute
  AuthenticatedOrganizationGovernanceIndexRoute: typeof AuthenticatedOrganizationGovernanceIndexRoute
  AuthenticatedOrganizationMembersIndexRoute: typeof AuthenticatedOrganizationMembersIndexRoute
  AuthenticatedOrganizationFinanceDonationsTabKeyRoute: typeof AuthenticatedOrganizationFinanceDonationsTabKeyRoute
  AuthenticatedOrganizationFinanceDonationsPagesRoute: typeof AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren
  AuthenticatedOrganizationMembersMemberIdTabKeyRoute: typeof AuthenticatedOrganizationMembersMemberIdTabKeyRoute
  AuthenticatedOrganizationFinanceDonationsIndexRoute: typeof AuthenticatedOrganizationFinanceDonationsIndexRoute
  AuthenticatedOrganizationMembersMemberIdIndexRoute: typeof AuthenticatedOrganizationMembersMemberIdIndexRoute
  AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute: typeof AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute
}

const AuthenticatedOrganizationRouteChildren: AuthenticatedOrganizationRouteChildren =
  {
    AuthenticatedOrganizationOrganizationSettingsRoute:
      AuthenticatedOrganizationOrganizationSettingsRouteWithChildren,
    AuthenticatedOrganizationBillingStripeCompleteRoute:
      AuthenticatedOrganizationBillingStripeCompleteRoute,
    AuthenticatedOrganizationBillingStripeRefreshRoute:
      AuthenticatedOrganizationBillingStripeRefreshRoute,
    AuthenticatedOrganizationCommunicationAnnouncementsRoute:
      AuthenticatedOrganizationCommunicationAnnouncementsRouteWithChildren,
    AuthenticatedOrganizationCommunicationEmailCampaignsRoute:
      AuthenticatedOrganizationCommunicationEmailCampaignsRoute,
    AuthenticatedOrganizationCommunicationMessagesRoute:
      AuthenticatedOrganizationCommunicationMessagesRoute,
    AuthenticatedOrganizationCommunicationNewslettersRoute:
      AuthenticatedOrganizationCommunicationNewslettersRoute,
    AuthenticatedOrganizationCommunicationSurveysRoute:
      AuthenticatedOrganizationCommunicationSurveysRoute,
    AuthenticatedOrganizationCommunicationTemplatesRoute:
      AuthenticatedOrganizationCommunicationTemplatesRouteWithChildren,
    AuthenticatedOrganizationContentDocumentsRoute:
      AuthenticatedOrganizationContentDocumentsRoute,
    AuthenticatedOrganizationContentMediaRoute:
      AuthenticatedOrganizationContentMediaRoute,
    AuthenticatedOrganizationContentResourcesRoute:
      AuthenticatedOrganizationContentResourcesRoute,
    AuthenticatedOrganizationDashboardCalendarRoute:
      AuthenticatedOrganizationDashboardCalendarRoute,
    AuthenticatedOrganizationDashboardOverviewRoute:
      AuthenticatedOrganizationDashboardOverviewRoute,
    AuthenticatedOrganizationDashboardRecentActivityRoute:
      AuthenticatedOrganizationDashboardRecentActivityRoute,
    AuthenticatedOrganizationEventsEventUuidRoute:
      AuthenticatedOrganizationEventsEventUuidRouteWithChildren,
    AuthenticatedOrganizationEventsAllEventsRoute:
      AuthenticatedOrganizationEventsAllEventsRoute,
    AuthenticatedOrganizationEventsAttendanceRoute:
      AuthenticatedOrganizationEventsAttendanceRoute,
    AuthenticatedOrganizationEventsCalendarRoute:
      AuthenticatedOrganizationEventsCalendarRoute,
    AuthenticatedOrganizationEventsCreateRoute:
      AuthenticatedOrganizationEventsCreateRoute,
    AuthenticatedOrganizationEventsVolunteeringRoute:
      AuthenticatedOrganizationEventsVolunteeringRoute,
    AuthenticatedOrganizationFinanceDuesRoute:
      AuthenticatedOrganizationFinanceDuesRouteWithChildren,
    AuthenticatedOrganizationFinanceFundraisingRoute:
      AuthenticatedOrganizationFinanceFundraisingRoute,
    AuthenticatedOrganizationFinanceInvoicesRoute:
      AuthenticatedOrganizationFinanceInvoicesRouteWithChildren,
    AuthenticatedOrganizationFinanceOrdersRoute:
      AuthenticatedOrganizationFinanceOrdersRouteWithChildren,
    AuthenticatedOrganizationFinanceOverviewRoute:
      AuthenticatedOrganizationFinanceOverviewRoute,
    AuthenticatedOrganizationFinanceReportsRoute:
      AuthenticatedOrganizationFinanceReportsRouteWithChildren,
    AuthenticatedOrganizationFinanceTransactionsRoute:
      AuthenticatedOrganizationFinanceTransactionsRouteWithChildren,
    AuthenticatedOrganizationGovernanceBylawsRoute:
      AuthenticatedOrganizationGovernanceBylawsRoute,
    AuthenticatedOrganizationGovernanceElectionsRoute:
      AuthenticatedOrganizationGovernanceElectionsRoute,
    AuthenticatedOrganizationGovernanceVotingRoute:
      AuthenticatedOrganizationGovernanceVotingRoute,
    AuthenticatedOrganizationImportResultUuidRoute:
      AuthenticatedOrganizationImportResultUuidRoute,
    AuthenticatedOrganizationMembersDirectoryRoute:
      AuthenticatedOrganizationMembersDirectoryRoute,
    AuthenticatedOrganizationMembersGroupsCommitteesRoute:
      AuthenticatedOrganizationMembersGroupsCommitteesRouteWithChildren,
    AuthenticatedOrganizationMembersHouseholdsRoute:
      AuthenticatedOrganizationMembersHouseholdsRouteWithChildren,
    AuthenticatedOrganizationMembersInvitesRoute:
      AuthenticatedOrganizationMembersInvitesRoute,
    AuthenticatedOrganizationMembersMembershipTiersRoute:
      AuthenticatedOrganizationMembersMembershipTiersRoute,
    AuthenticatedOrganizationCommunicationIndexRoute:
      AuthenticatedOrganizationCommunicationIndexRoute,
    AuthenticatedOrganizationContentIndexRoute:
      AuthenticatedOrganizationContentIndexRoute,
    AuthenticatedOrganizationDashboardIndexRoute:
      AuthenticatedOrganizationDashboardIndexRoute,
    AuthenticatedOrganizationEventsIndexRoute:
      AuthenticatedOrganizationEventsIndexRoute,
    AuthenticatedOrganizationFinanceIndexRoute:
      AuthenticatedOrganizationFinanceIndexRoute,
    AuthenticatedOrganizationGovernanceIndexRoute:
      AuthenticatedOrganizationGovernanceIndexRoute,
    AuthenticatedOrganizationMembersIndexRoute:
      AuthenticatedOrganizationMembersIndexRoute,
    AuthenticatedOrganizationFinanceDonationsTabKeyRoute:
      AuthenticatedOrganizationFinanceDonationsTabKeyRoute,
    AuthenticatedOrganizationFinanceDonationsPagesRoute:
      AuthenticatedOrganizationFinanceDonationsPagesRouteWithChildren,
    AuthenticatedOrganizationMembersMemberIdTabKeyRoute:
      AuthenticatedOrganizationMembersMemberIdTabKeyRoute,
    AuthenticatedOrganizationFinanceDonationsIndexRoute:
      AuthenticatedOrganizationFinanceDonationsIndexRoute,
    AuthenticatedOrganizationMembersMemberIdIndexRoute:
      AuthenticatedOrganizationMembersMemberIdIndexRoute,
    AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute:
      AuthenticatedOrganizationFinanceDonationsRecordsDonationUuidRoute,
  }

const AuthenticatedOrganizationRouteWithChildren =
  AuthenticatedOrganizationRoute._addFileChildren(
    AuthenticatedOrganizationRouteChildren,
  )

interface AuthenticatedOrganizationsRouteChildren {
  AuthenticatedOrganizationsOrganizationsCreateRoute: typeof AuthenticatedOrganizationsOrganizationsCreateRoute
  AuthenticatedOrganizationsOrganizationsIndexRoute: typeof AuthenticatedOrganizationsOrganizationsIndexRoute
}

const AuthenticatedOrganizationsRouteChildren: AuthenticatedOrganizationsRouteChildren =
  {
    AuthenticatedOrganizationsOrganizationsCreateRoute:
      AuthenticatedOrganizationsOrganizationsCreateRoute,
    AuthenticatedOrganizationsOrganizationsIndexRoute:
      AuthenticatedOrganizationsOrganizationsIndexRoute,
  }

const AuthenticatedOrganizationsRouteWithChildren =
  AuthenticatedOrganizationsRoute._addFileChildren(
    AuthenticatedOrganizationsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRouteWithChildren
  AuthenticatedOrganizationsRoute: typeof AuthenticatedOrganizationsRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRouteWithChildren,
  AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedConfirmEmailRoute: typeof UnauthenticatedConfirmEmailRoute
  UnauthenticatedForgotPasswordRoute: typeof UnauthenticatedForgotPasswordRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedResetPasswordRoute: typeof UnauthenticatedResetPasswordRoute
  UnauthenticatedSignupRoute: typeof UnauthenticatedSignupRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedConfirmEmailRoute: UnauthenticatedConfirmEmailRoute,
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedResetPasswordRoute: UnauthenticatedResetPasswordRoute,
  UnauthenticatedSignupRoute: UnauthenticatedSignupRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  AuthenticateRoute: AuthenticateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
